//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { BaseApiClass } from './api-base';import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AuthClient extends BaseApiClass {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    login(login: LoginRequest, cancelToken?: CancelToken): Promise<LoginResult> {
        let url_ = this.baseUrl + "/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogin(_response));
        });
    }

    protected processLogin(response: AxiosResponse): Promise<LoginResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginResult.fromJS(resultData200);
            return Promise.resolve<LoginResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginResult>(null as any);
    }
}

export class CompanyClient extends BaseApiClass {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getCompanyListIfDifferent(recordLimit: number | null | undefined, ifHashDifferentTo: string | null | undefined, cancelToken?: CancelToken): Promise<HashedPayloadOfListOfCompanyListData> {
        let url_ = this.baseUrl + "/company/list?";
        if (recordLimit !== undefined && recordLimit !== null)
            url_ += "recordLimit=" + encodeURIComponent("" + recordLimit) + "&";
        if (ifHashDifferentTo !== undefined && ifHashDifferentTo !== null)
            url_ += "ifHashDifferentTo=" + encodeURIComponent("" + ifHashDifferentTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCompanyListIfDifferent(_response));
        });
    }

    protected processGetCompanyListIfDifferent(response: AxiosResponse): Promise<HashedPayloadOfListOfCompanyListData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HashedPayloadOfListOfCompanyListData.fromJS(resultData200);
            return Promise.resolve<HashedPayloadOfListOfCompanyListData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HashedPayloadOfListOfCompanyListData>(null as any);
    }

    getCompanyById(companyId: number, cancelToken?: CancelToken): Promise<CompanyData> {
        let url_ = this.baseUrl + "/company/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCompanyById(_response));
        });
    }

    protected processGetCompanyById(response: AxiosResponse): Promise<CompanyData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompanyData.fromJS(resultData200);
            return Promise.resolve<CompanyData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyData>(null as any);
    }

    updateCompany(model: CompanyData, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/company/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateCompany(_response));
        });
    }

    protected processUpdateCompany(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    addCompany(model: CompanyData, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/company/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddCompany(_response));
        });
    }

    protected processAddCompany(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getCustomerLogos(includeDeleted: boolean | undefined, includeUnassignedLogos: boolean | undefined, cancelToken?: CancelToken): Promise<CustomerLogoData[]> {
        let url_ = this.baseUrl + "/company/customer-templates?";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (includeUnassignedLogos === null)
            throw new globalThis.Error("The parameter 'includeUnassignedLogos' cannot be null.");
        else if (includeUnassignedLogos !== undefined)
            url_ += "includeUnassignedLogos=" + encodeURIComponent("" + includeUnassignedLogos) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCustomerLogos(_response));
        });
    }

    protected processGetCustomerLogos(response: AxiosResponse): Promise<CustomerLogoData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerLogoData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomerLogoData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerLogoData[]>(null as any);
    }

    getCustomerLogoOptions( cancelToken?: CancelToken): Promise<CustomerLogoOption[]> {
        let url_ = this.baseUrl + "/company/logo-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCustomerLogoOptions(_response));
        });
    }

    protected processGetCustomerLogoOptions(response: AxiosResponse): Promise<CustomerLogoOption[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerLogoOption.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomerLogoOption[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerLogoOption[]>(null as any);
    }

    updateCompanyBwofTemplateLogo(model: UpdateCompanyBwofTemplateLogoCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/company/bwof-template-logo/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateCompanyBwofTemplateLogo(_response));
        });
    }

    protected processUpdateCompanyBwofTemplateLogo(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    assignCompanyBwofTemplateLogo(model: AssignCompanyBwofTemplateLogoCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/company/bwof-template-logo/assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssignCompanyBwofTemplateLogo(_response));
        });
    }

    protected processAssignCompanyBwofTemplateLogo(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateCustomerLogo(model: UpdateCustomerLogoCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/company/bwof-template-logo/rename";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateCustomerLogo(_response));
        });
    }

    protected processUpdateCustomerLogo(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateCompanyDisplayCompassLogo(model: UpdateCompanyDisplayCompassLogoCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/company/bwof-template-logo/display-compass-logo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateCompanyDisplayCompassLogo(_response));
        });
    }

    protected processUpdateCompanyDisplayCompassLogo(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    syncPropertiesToCustomerLogo(model: SyncPropertiesToCustomerLogoCommand, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/company/bwof-template-logo/sync-properties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSyncPropertiesToCustomerLogo(_response));
        });
    }

    protected processSyncPropertiesToCustomerLogo(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getPropertiesWithLogoOverride(companyId: number, cancelToken?: CancelToken): Promise<PropertyLogoOverrideSummary[]> {
        let url_ = this.baseUrl + "/company/bwof-template-logo/overridden-properties/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPropertiesWithLogoOverride(_response));
        });
    }

    protected processGetPropertiesWithLogoOverride(response: AxiosResponse): Promise<PropertyLogoOverrideSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyLogoOverrideSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PropertyLogoOverrideSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyLogoOverrideSummary[]>(null as any);
    }

    syncAffectedPropertiesExcelExport(request: SyncAffectedPropertiesExcelExportRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/bwof-template-logo/overridden-properties-excel-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSyncAffectedPropertiesExcelExport(_response));
        });
    }

    protected processSyncAffectedPropertiesExcelExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBillingEntities(companyIds: number[] | null | undefined, cancelToken?: CancelToken): Promise<BillingEntityData[]> {
        let url_ = this.baseUrl + "/company/billingEntityList?";
        if (companyIds !== undefined && companyIds !== null)
            companyIds && companyIds.forEach(item => { url_ += "companyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBillingEntities(_response));
        });
    }

    protected processGetBillingEntities(response: AxiosResponse): Promise<BillingEntityData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillingEntityData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BillingEntityData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillingEntityData[]>(null as any);
    }

    getCompanyPricingSummaryById(companyId: number, cancelToken?: CancelToken): Promise<PricingSummary> {
        let url_ = this.baseUrl + "/company/pricing-summary/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCompanyPricingSummaryById(_response));
        });
    }

    protected processGetCompanyPricingSummaryById(response: AxiosResponse): Promise<PricingSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PricingSummary.fromJS(resultData200);
            return Promise.resolve<PricingSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PricingSummary>(null as any);
    }

    updateCompanyPricingSummary(services: PropertyServiceData[], cancelToken?: CancelToken): Promise<PricingSummary> {
        let url_ = this.baseUrl + "/company/pricing-summary/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(services);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateCompanyPricingSummary(_response));
        });
    }

    protected processUpdateCompanyPricingSummary(response: AxiosResponse): Promise<PricingSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PricingSummary.fromJS(resultData200);
            return Promise.resolve<PricingSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PricingSummary>(null as any);
    }

    customerLogosExcelExport(request: CustomerLogosExcelExportRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/customer-templates-excel-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCustomerLogosExcelExport(_response));
        });
    }

    protected processCustomerLogosExcelExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    companyListExcelExport(getFilteredCompanyListQuery: GetFilteredCompanySummaryListQuery, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/company-list-excel-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getFilteredCompanyListQuery);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompanyListExcelExport(_response));
        });
    }

    protected processCompanyListExcelExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ContactClient extends BaseApiClass {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * Retrieves a list of contacts if the computed hash of the entire dataset differs from the provided hash
     * @param recordLimit (optional) 
     * @param ifHashDifferentTo (optional) 
     */
    getContacts(recordLimit: number | null | undefined, ifHashDifferentTo: string | null | undefined, cancelToken?: CancelToken): Promise<HashedPayloadOfICollectionOfContactListMember> {
        let url_ = this.baseUrl + "/contact?";
        if (recordLimit !== undefined && recordLimit !== null)
            url_ += "recordLimit=" + encodeURIComponent("" + recordLimit) + "&";
        if (ifHashDifferentTo !== undefined && ifHashDifferentTo !== null)
            url_ += "ifHashDifferentTo=" + encodeURIComponent("" + ifHashDifferentTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetContacts(_response));
        });
    }

    protected processGetContacts(response: AxiosResponse): Promise<HashedPayloadOfICollectionOfContactListMember> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HashedPayloadOfICollectionOfContactListMember.fromJS(resultData200);
            return Promise.resolve<HashedPayloadOfICollectionOfContactListMember>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HashedPayloadOfICollectionOfContactListMember>(null as any);
    }

    /**
     * Searches the contact list and returns matching results, completely free of any hashed payload obscurities
     */
    searchContacts(query: GetContactListQuery, cancelToken?: CancelToken): Promise<ContactListMember[]> {
        let url_ = this.baseUrl + "/contact/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSearchContacts(_response));
        });
    }

    protected processSearchContacts(response: AxiosResponse): Promise<ContactListMember[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactListMember.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ContactListMember[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactListMember[]>(null as any);
    }

    /**
     * Exports the contact list to excel
     */
    exportContacts(query: GetContactListExcelExportQuery, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/contact/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportContacts(_response));
        });
    }

    protected processExportContacts(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Restores contact details of a contact or site contact
     */
    restoreContact(command: RestoreContactCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/contact/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRestoreContact(_response));
        });
    }

    protected processRestoreContact(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Archives contact details of a contact or site contact
     */
    archiveContact(command: ArchiveContactCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/contact/archive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processArchiveContact(_response));
        });
    }

    protected processArchiveContact(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Syncs contact details for contacts and/or site contacts with the same email
     */
    bulkUpdateContacts(command: BulkUpdateContactsCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/contact/sync-contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processBulkUpdateContacts(_response));
        });
    }

    protected processBulkUpdateContacts(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Updates contact details of contacts and/or site contacts
     */
    updateContacts(command: UpdateContactsCommand, cancelToken?: CancelToken): Promise<ContactListMember[]> {
        let url_ = this.baseUrl + "/contact/update-contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateContacts(_response));
        });
    }

    protected processUpdateContacts(response: AxiosResponse): Promise<ContactListMember[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactListMember.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ContactListMember[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactListMember[]>(null as any);
    }

    /**
     * Archives and syncs duplicate contacts and/or site contacts
     */
    archiveContacts(command: ArchiveContactsCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/contact/archive-contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processArchiveContacts(_response));
        });
    }

    protected processArchiveContacts(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Restores and syncs duplicate contacts and/or site contacts
     */
    restoreContacts(command: RestoreContactsCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/contact/restore-contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRestoreContacts(_response));
        });
    }

    protected processRestoreContacts(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Retrieves matching contact and base 64 signature linked from current login id for reports
     */
    getReportContact( cancelToken?: CancelToken): Promise<ReportContact> {
        let url_ = this.baseUrl + "/contact/GetReportContact";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReportContact(_response));
        });
    }

    protected processGetReportContact(response: AxiosResponse): Promise<ReportContact> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportContact.fromJS(resultData200);
            return Promise.resolve<ReportContact>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportContact>(null as any);
    }
}

export class DocumentClient extends BaseApiClass {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    uploadDocuments(propertyId: number | undefined, files: FileParameter[] | null | undefined, cancelToken?: CancelToken): Promise<DocumentData[]> {
        let url_ = this.baseUrl + "/document/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (propertyId === null || propertyId === undefined)
            throw new globalThis.Error("The parameter 'propertyId' cannot be null.");
        else
            content_.append("PropertyId", propertyId.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUploadDocuments(_response));
        });
    }

    protected processUploadDocuments(response: AxiosResponse): Promise<DocumentData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DocumentData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentData[]>(null as any);
    }

    generateDocument(request: GeneratePdfRequest, cancelToken?: CancelToken): Promise<DocumentData[]> {
        let url_ = this.baseUrl + "/document/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateDocument(_response));
        });
    }

    protected processGenerateDocument(response: AxiosResponse): Promise<DocumentData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DocumentData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentData[]>(null as any);
    }

    downloadDocumentIncorrectMethod( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/document/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadDocumentIncorrectMethod(_response));
        });
    }

    protected processDownloadDocumentIncorrectMethod(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadDocument(request: DownloadDocumentRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/document/download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadDocument(_response));
        });
    }

    protected processDownloadDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class EmailClient extends BaseApiClass {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    get12aEmaiList( cancelToken?: CancelToken): Promise<GetAutomationEmailResponseModel> {
        let url_ = this.baseUrl + "/email/12aEmailList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet12aEmaiList(_response));
        });
    }

    protected processGet12aEmaiList(response: AxiosResponse): Promise<GetAutomationEmailResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAutomationEmailResponseModel.fromJS(resultData200);
            return Promise.resolve<GetAutomationEmailResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAutomationEmailResponseModel>(null as any);
    }

    get12aSentEmaiList( cancelToken?: CancelToken): Promise<AutomatedEmailData[]> {
        let url_ = this.baseUrl + "/email/12aSentEmailList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet12aSentEmaiList(_response));
        });
    }

    protected processGet12aSentEmaiList(response: AxiosResponse): Promise<AutomatedEmailData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AutomatedEmailData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AutomatedEmailData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutomatedEmailData[]>(null as any);
    }

    getTrialEvacuationEmailList( cancelToken?: CancelToken): Promise<GetAutomationEmailResponseModel> {
        let url_ = this.baseUrl + "/email/trial-evacuation-email-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTrialEvacuationEmailList(_response));
        });
    }

    protected processGetTrialEvacuationEmailList(response: AxiosResponse): Promise<GetAutomationEmailResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAutomationEmailResponseModel.fromJS(resultData200);
            return Promise.resolve<GetAutomationEmailResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAutomationEmailResponseModel>(null as any);
    }

    send12aEmails(request: SendSnoozeEmailsRequest, cancelToken?: CancelToken): Promise<GetAutomationEmailResponseModel> {
        let url_ = this.baseUrl + "/email/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSend12aEmails(_response));
        });
    }

    protected processSend12aEmails(response: AxiosResponse): Promise<GetAutomationEmailResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAutomationEmailResponseModel.fromJS(resultData200);
            return Promise.resolve<GetAutomationEmailResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAutomationEmailResponseModel>(null as any);
    }

    snoozeEmails(request: SendSnoozeEmailsRequest, cancelToken?: CancelToken): Promise<GetAutomationEmailResponseModel> {
        let url_ = this.baseUrl + "/email/snooze";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSnoozeEmails(_response));
        });
    }

    protected processSnoozeEmails(response: AxiosResponse): Promise<GetAutomationEmailResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAutomationEmailResponseModel.fromJS(resultData200);
            return Promise.resolve<GetAutomationEmailResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAutomationEmailResponseModel>(null as any);
    }

    resumeEmails(request: SendSnoozeEmailsRequest, cancelToken?: CancelToken): Promise<GetAutomationEmailResponseModel> {
        let url_ = this.baseUrl + "/email/resume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResumeEmails(_response));
        });
    }

    protected processResumeEmails(response: AxiosResponse): Promise<GetAutomationEmailResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAutomationEmailResponseModel.fromJS(resultData200);
            return Promise.resolve<GetAutomationEmailResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAutomationEmailResponseModel>(null as any);
    }

    trigger12aEmails( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/email/trigger";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTrigger12aEmails(_response));
        });
    }

    protected processTrigger12aEmails(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getRenderedEmailTemplate(getRenderedEmailTemplateQueryModel: GetRenderedEmailTemplateQuery, cancelToken?: CancelToken): Promise<GetRenderedEmailTemplateResponse> {
        let url_ = this.baseUrl + "/email/email-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getRenderedEmailTemplateQueryModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRenderedEmailTemplate(_response));
        });
    }

    protected processGetRenderedEmailTemplate(response: AxiosResponse): Promise<GetRenderedEmailTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRenderedEmailTemplateResponse.fromJS(resultData200);
            return Promise.resolve<GetRenderedEmailTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRenderedEmailTemplateResponse>(null as any);
    }

    generateAndSendEmail(generateAndSendEmailCommandModel: GenerateAndSendEmailCommand, cancelToken?: CancelToken): Promise<PropertyServiceData[]> {
        let url_ = this.baseUrl + "/email/generate-send-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(generateAndSendEmailCommandModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateAndSendEmail(_response));
        });
    }

    protected processGenerateAndSendEmail(response: AxiosResponse): Promise<PropertyServiceData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyServiceData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PropertyServiceData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyServiceData[]>(null as any);
    }
}

export class PropertyClient extends BaseApiClass {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getPropertyListIfDifferent(recordLimit: number | null | undefined, ifHashDifferentTo: string | null | undefined, cancelToken?: CancelToken): Promise<HashedPayloadOfListOfPropertySummary> {
        let url_ = this.baseUrl + "/property/list?";
        if (recordLimit !== undefined && recordLimit !== null)
            url_ += "recordLimit=" + encodeURIComponent("" + recordLimit) + "&";
        if (ifHashDifferentTo !== undefined && ifHashDifferentTo !== null)
            url_ += "ifHashDifferentTo=" + encodeURIComponent("" + ifHashDifferentTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPropertyListIfDifferent(_response));
        });
    }

    protected processGetPropertyListIfDifferent(response: AxiosResponse): Promise<HashedPayloadOfListOfPropertySummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HashedPayloadOfListOfPropertySummary.fromJS(resultData200);
            return Promise.resolve<HashedPayloadOfListOfPropertySummary>(result200);

        } else if (status === 304) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HashedPayloadOfListOfPropertySummary>(null as any);
    }

    getPropertyDashboard(getPropertyDashboardQuery: GetPropertyDashboardQuery, cancelToken?: CancelToken): Promise<PropertyDashboardData[]> {
        let url_ = this.baseUrl + "/property/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getPropertyDashboardQuery);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPropertyDashboard(_response));
        });
    }

    protected processGetPropertyDashboard(response: AxiosResponse): Promise<PropertyDashboardData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyDashboardData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PropertyDashboardData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyDashboardData[]>(null as any);
    }

    updatePropertyServiceDates(updatePropertyServiceDatesCommand: UpdatePropertyServiceDatesCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/property/update-property-service-dates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePropertyServiceDatesCommand);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdatePropertyServiceDates(_response));
        });
    }

    protected processUpdatePropertyServiceDates(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPropertyById(propertyId: number, cancelToken?: CancelToken): Promise<PropertyData> {
        let url_ = this.baseUrl + "/property/{propertyId}";
        if (propertyId === undefined || propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPropertyById(_response));
        });
    }

    protected processGetPropertyById(response: AxiosResponse): Promise<PropertyData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PropertyData.fromJS(resultData200);
            return Promise.resolve<PropertyData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyData>(null as any);
    }

    updateProperty(propertyId: number, model: PropertyData, cancelToken?: CancelToken): Promise<PropertyData> {
        let url_ = this.baseUrl + "/property/{propertyId}";
        if (propertyId === undefined || propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateProperty(_response));
        });
    }

    protected processUpdateProperty(response: AxiosResponse): Promise<PropertyData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PropertyData.fromJS(resultData200);
            return Promise.resolve<PropertyData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyData>(null as any);
    }

    addProperty(model: PropertyData, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/property/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddProperty(_response));
        });
    }

    protected processAddProperty(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    dashboardExcelExport(propertyDashboardQueryParameters: GetPropertyDashboardQuery, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/property/dashboard-excel-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(propertyDashboardQueryParameters);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDashboardExcelExport(_response));
        });
    }

    protected processDashboardExcelExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    propertyListExcelExport(propertyListQueryParameters: GetPropertyListQuery, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/property/property-list-excel-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(propertyListQueryParameters);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPropertyListExcelExport(_response));
        });
    }

    protected processPropertyListExcelExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    propertyServiceAuditExport(propertyServiceAuditQueryParameters: GetPropertyServiceAuditQuery, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/property/property-service-audit-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(propertyServiceAuditQueryParameters);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPropertyServiceAuditExport(_response));
        });
    }

    protected processPropertyServiceAuditExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ServiceClient extends BaseApiClass {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getAllServices(getAllServicesQuery: GetAllAccessibleServicesQuery, cancelToken?: CancelToken): Promise<ServiceData[]> {
        let url_ = this.baseUrl + "/service/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getAllServicesQuery);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllServices(_response));
        });
    }

    protected processGetAllServices(response: AxiosResponse): Promise<ServiceData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceData[]>(null as any);
    }

    updateServiceDefinitions(model: ServiceData[], cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/service";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateServiceDefinitions(_response));
        });
    }

    protected processUpdateServiceDefinitions(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class UserClient extends BaseApiClass {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getUserList( cancelToken?: CancelToken): Promise<UserData[]> {
        let url_ = this.baseUrl + "/user/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserList(_response));
        });
    }

    protected processGetUserList(response: AxiosResponse): Promise<UserData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserData[]>(null as any);
    }

    getUserById(loginId: number, cancelToken?: CancelToken): Promise<UserData> {
        let url_ = this.baseUrl + "/user/{loginId}";
        if (loginId === undefined || loginId === null)
            throw new globalThis.Error("The parameter 'loginId' must be defined.");
        url_ = url_.replace("{loginId}", encodeURIComponent("" + loginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserById(_response));
        });
    }

    protected processGetUserById(response: AxiosResponse): Promise<UserData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserData.fromJS(resultData200);
            return Promise.resolve<UserData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserData>(null as any);
    }

    changePassword(model: ChangePasswordRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/user/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChangePassword(_response));
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateUserDetails(command: UpdateUserDetailsCommand, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/user/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateUserDetails(_response));
        });
    }

    protected processUpdateUserDetails(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    addUser(addUserCommandModel: AddUserCommand, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/user/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addUserCommandModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddUser(_response));
        });
    }

    protected processAddUser(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    updateSignature(command: UpdateSignatureCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/user/signature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateSignature(_response));
        });
    }

    protected processUpdateSignature(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class LoginResult implements ILoginResult {
    message?: string;
    token?: string;

    constructor(data?: ILoginResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): LoginResult {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["token"] = this.token;
        return data;
    }
}

export interface ILoginResult {
    message?: string;
    token?: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class LoginRequest implements ILoginRequest {
    userName!: string;
    password!: string;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginRequest {
    userName: string;
    password: string;
}

export class HashedPayloadOfListOfCompanyListData implements IHashedPayloadOfListOfCompanyListData {
    data?: CompanyListData[] | undefined;
    hash?: string;
    errorMessage?: string | undefined;

    constructor(data?: IHashedPayloadOfListOfCompanyListData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CompanyListData.fromJS(item));
            }
            this.hash = _data["hash"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): HashedPayloadOfListOfCompanyListData {
        data = typeof data === 'object' ? data : {};
        let result = new HashedPayloadOfListOfCompanyListData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["hash"] = this.hash;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IHashedPayloadOfListOfCompanyListData {
    data?: CompanyListData[] | undefined;
    hash?: string;
    errorMessage?: string | undefined;
}

export class CompanyListData implements ICompanyListData {
    id?: number;
    name?: string;
    loc?: string | undefined;
    isle?: string | undefined;
    conts?: string | undefined;
    flags?: string | undefined;
    np?: number | undefined;
    nameAndId?: string;

    constructor(data?: ICompanyListData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.loc = _data["loc"];
            this.isle = _data["isle"];
            this.conts = _data["conts"];
            this.flags = _data["flags"];
            this.np = _data["np"];
            this.nameAndId = _data["nameAndId"];
        }
    }

    static fromJS(data: any): CompanyListData {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyListData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["loc"] = this.loc;
        data["isle"] = this.isle;
        data["conts"] = this.conts;
        data["flags"] = this.flags;
        data["np"] = this.np;
        data["nameAndId"] = this.nameAndId;
        return data;
    }
}

export interface ICompanyListData {
    id?: number;
    name?: string;
    loc?: string | undefined;
    isle?: string | undefined;
    conts?: string | undefined;
    flags?: string | undefined;
    np?: number | undefined;
    nameAndId?: string;
}

export class CompanyData implements ICompanyData {
    companyId?: number;
    companyName?: string;
    companyShortName?: string | undefined;
    streetAddress?: string | undefined;
    postalAddress?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
    island?: string | undefined;
    companyPhone?: string | undefined;
    companyNotes?: string | undefined;
    compassConsultant?: number | undefined;
    accountNumber?: string | undefined;
    isCustomer?: boolean;
    isSupplier?: boolean;
    isOwner?: boolean;
    isAuthority?: boolean;
    enableEmailAutomation?: boolean;
    enableCustomerCcEmails?: boolean;
    whenCreated?: Date | undefined;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;
    active?: boolean;
    ccCustomerOn12aFollowUp?: boolean;
    billingEntities?: BillingEntityData[];
    contacts?: ContactData[];
    associatedProperties?: PropertySummary[];

    constructor(data?: ICompanyData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.companyShortName = _data["companyShortName"];
            this.streetAddress = _data["streetAddress"];
            this.postalAddress = _data["postalAddress"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.island = _data["island"];
            this.companyPhone = _data["companyPhone"];
            this.companyNotes = _data["companyNotes"];
            this.compassConsultant = _data["compassConsultant"];
            this.accountNumber = _data["accountNumber"];
            this.isCustomer = _data["isCustomer"];
            this.isSupplier = _data["isSupplier"];
            this.isOwner = _data["isOwner"];
            this.isAuthority = _data["isAuthority"];
            this.enableEmailAutomation = _data["enableEmailAutomation"];
            this.enableCustomerCcEmails = _data["enableCustomerCcEmails"];
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : undefined as any;
            this.whenUpdated = _data["whenUpdated"] ? new Date(_data["whenUpdated"].toString()) : undefined as any;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : undefined as any;
            this.active = _data["active"];
            this.ccCustomerOn12aFollowUp = _data["ccCustomerOn12aFollowUp"];
            if (Array.isArray(_data["billingEntities"])) {
                this.billingEntities = [] as any;
                for (let item of _data["billingEntities"])
                    this.billingEntities!.push(BillingEntityData.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactData.fromJS(item));
            }
            if (Array.isArray(_data["associatedProperties"])) {
                this.associatedProperties = [] as any;
                for (let item of _data["associatedProperties"])
                    this.associatedProperties!.push(PropertySummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyData {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["companyShortName"] = this.companyShortName;
        data["streetAddress"] = this.streetAddress;
        data["postalAddress"] = this.postalAddress;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["island"] = this.island;
        data["companyPhone"] = this.companyPhone;
        data["companyNotes"] = this.companyNotes;
        data["compassConsultant"] = this.compassConsultant;
        data["accountNumber"] = this.accountNumber;
        data["isCustomer"] = this.isCustomer;
        data["isSupplier"] = this.isSupplier;
        data["isOwner"] = this.isOwner;
        data["isAuthority"] = this.isAuthority;
        data["enableEmailAutomation"] = this.enableEmailAutomation;
        data["enableCustomerCcEmails"] = this.enableCustomerCcEmails;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : undefined as any;
        data["whenUpdated"] = this.whenUpdated ? this.whenUpdated.toISOString() : undefined as any;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : undefined as any;
        data["active"] = this.active;
        data["ccCustomerOn12aFollowUp"] = this.ccCustomerOn12aFollowUp;
        if (Array.isArray(this.billingEntities)) {
            data["billingEntities"] = [];
            for (let item of this.billingEntities)
                data["billingEntities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.associatedProperties)) {
            data["associatedProperties"] = [];
            for (let item of this.associatedProperties)
                data["associatedProperties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICompanyData {
    companyId?: number;
    companyName?: string;
    companyShortName?: string | undefined;
    streetAddress?: string | undefined;
    postalAddress?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
    island?: string | undefined;
    companyPhone?: string | undefined;
    companyNotes?: string | undefined;
    compassConsultant?: number | undefined;
    accountNumber?: string | undefined;
    isCustomer?: boolean;
    isSupplier?: boolean;
    isOwner?: boolean;
    isAuthority?: boolean;
    enableEmailAutomation?: boolean;
    enableCustomerCcEmails?: boolean;
    whenCreated?: Date | undefined;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;
    active?: boolean;
    ccCustomerOn12aFollowUp?: boolean;
    billingEntities?: BillingEntityData[];
    contacts?: ContactData[];
    associatedProperties?: PropertySummary[];
}

export class BillingEntityData implements IBillingEntityData {
    billingEntityId?: number;
    companyId?: number;
    billingEntityName?: string;
    accountNumber?: string | undefined;
    whenCreated?: Date | undefined;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;

    constructor(data?: IBillingEntityData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingEntityId = _data["billingEntityId"];
            this.companyId = _data["companyId"];
            this.billingEntityName = _data["billingEntityName"];
            this.accountNumber = _data["accountNumber"];
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : undefined as any;
            this.whenUpdated = _data["whenUpdated"] ? new Date(_data["whenUpdated"].toString()) : undefined as any;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BillingEntityData {
        data = typeof data === 'object' ? data : {};
        let result = new BillingEntityData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingEntityId"] = this.billingEntityId;
        data["companyId"] = this.companyId;
        data["billingEntityName"] = this.billingEntityName;
        data["accountNumber"] = this.accountNumber;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : undefined as any;
        data["whenUpdated"] = this.whenUpdated ? this.whenUpdated.toISOString() : undefined as any;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : undefined as any;
        return data;
    }
}

export interface IBillingEntityData {
    billingEntityId?: number;
    companyId?: number;
    billingEntityName?: string;
    accountNumber?: string | undefined;
    whenCreated?: Date | undefined;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;
}

export class ContactData implements IContactData {
    contactId?: number;
    companyId?: number | undefined;
    propertyId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    ddi?: string | undefined;
    loginAccess?: boolean;
    mailingList?: boolean;
    isInvoiceRecipient?: boolean | undefined;
    enableAutomationEmails?: boolean;
    whenCreated?: Date | undefined;
    active?: boolean;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;

    constructor(data?: IContactData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.companyId = _data["companyId"];
            this.propertyId = _data["propertyId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.jobTitle = _data["jobTitle"];
            this.email = _data["email"];
            this.mobile = _data["mobile"];
            this.ddi = _data["ddi"];
            this.loginAccess = _data["loginAccess"];
            this.mailingList = _data["mailingList"];
            this.isInvoiceRecipient = _data["isInvoiceRecipient"];
            this.enableAutomationEmails = _data["enableAutomationEmails"];
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : undefined as any;
            this.active = _data["active"];
            this.whenUpdated = _data["whenUpdated"] ? new Date(_data["whenUpdated"].toString()) : undefined as any;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ContactData {
        data = typeof data === 'object' ? data : {};
        let result = new ContactData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["companyId"] = this.companyId;
        data["propertyId"] = this.propertyId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["jobTitle"] = this.jobTitle;
        data["email"] = this.email;
        data["mobile"] = this.mobile;
        data["ddi"] = this.ddi;
        data["loginAccess"] = this.loginAccess;
        data["mailingList"] = this.mailingList;
        data["isInvoiceRecipient"] = this.isInvoiceRecipient;
        data["enableAutomationEmails"] = this.enableAutomationEmails;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : undefined as any;
        data["active"] = this.active;
        data["whenUpdated"] = this.whenUpdated ? this.whenUpdated.toISOString() : undefined as any;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : undefined as any;
        return data;
    }
}

export interface IContactData {
    contactId?: number;
    companyId?: number | undefined;
    propertyId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    ddi?: string | undefined;
    loginAccess?: boolean;
    mailingList?: boolean;
    isInvoiceRecipient?: boolean | undefined;
    enableAutomationEmails?: boolean;
    whenCreated?: Date | undefined;
    active?: boolean;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;
}

export class PropertySummary implements IPropertySummary {
    propertyId?: number;
    propertyNameAndLocation?: string;
    propertyLocation?: string | undefined;
    active?: boolean;
    customerPropertyRef?: string | undefined;
    isle?: string | undefined;
    buildingName?: string | undefined;
    complianceSchedule?: string | undefined;

    constructor(data?: IPropertySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.propertyNameAndLocation = _data["propertyNameAndLocation"];
            this.propertyLocation = _data["propertyLocation"];
            this.active = _data["active"];
            this.customerPropertyRef = _data["customerPropertyRef"];
            this.isle = _data["isle"];
            this.buildingName = _data["buildingName"];
            this.complianceSchedule = _data["complianceSchedule"];
        }
    }

    static fromJS(data: any): PropertySummary {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["propertyNameAndLocation"] = this.propertyNameAndLocation;
        data["propertyLocation"] = this.propertyLocation;
        data["active"] = this.active;
        data["customerPropertyRef"] = this.customerPropertyRef;
        data["isle"] = this.isle;
        data["buildingName"] = this.buildingName;
        data["complianceSchedule"] = this.complianceSchedule;
        return data;
    }
}

export interface IPropertySummary {
    propertyId?: number;
    propertyNameAndLocation?: string;
    propertyLocation?: string | undefined;
    active?: boolean;
    customerPropertyRef?: string | undefined;
    isle?: string | undefined;
    buildingName?: string | undefined;
    complianceSchedule?: string | undefined;
}

export class CustomerLogoData implements ICustomerLogoData {
    companyId?: number | undefined;
    companyName?: string;
    isCompanyDeleted?: boolean;
    isActive?: boolean;
    customerLogoId?: number | undefined;
    logoName?: string | undefined;
    bwofTemplateLogo?: string | undefined;
    isCompassDefault?: boolean;
    displayCompassLogo?: boolean;
    usedByOthersCount?: number;
    sharedWith?: LogoReference[];
    propertiesWithOverrideCount?: number;
    propertiesAssociatedCount?: number;
    propertiesWithLogoCount?: number;
    ownPropertiesWithLogo?: LogoReference[];

    constructor(data?: ICustomerLogoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.isCompanyDeleted = _data["isCompanyDeleted"];
            this.isActive = _data["isActive"];
            this.customerLogoId = _data["customerLogoId"];
            this.logoName = _data["logoName"];
            this.bwofTemplateLogo = _data["bwofTemplateLogo"];
            this.isCompassDefault = _data["isCompassDefault"];
            this.displayCompassLogo = _data["displayCompassLogo"];
            this.usedByOthersCount = _data["usedByOthersCount"];
            if (Array.isArray(_data["sharedWith"])) {
                this.sharedWith = [] as any;
                for (let item of _data["sharedWith"])
                    this.sharedWith!.push(LogoReference.fromJS(item));
            }
            this.propertiesWithOverrideCount = _data["propertiesWithOverrideCount"];
            this.propertiesAssociatedCount = _data["propertiesAssociatedCount"];
            this.propertiesWithLogoCount = _data["propertiesWithLogoCount"];
            if (Array.isArray(_data["ownPropertiesWithLogo"])) {
                this.ownPropertiesWithLogo = [] as any;
                for (let item of _data["ownPropertiesWithLogo"])
                    this.ownPropertiesWithLogo!.push(LogoReference.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerLogoData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLogoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["isCompanyDeleted"] = this.isCompanyDeleted;
        data["isActive"] = this.isActive;
        data["customerLogoId"] = this.customerLogoId;
        data["logoName"] = this.logoName;
        data["bwofTemplateLogo"] = this.bwofTemplateLogo;
        data["isCompassDefault"] = this.isCompassDefault;
        data["displayCompassLogo"] = this.displayCompassLogo;
        data["usedByOthersCount"] = this.usedByOthersCount;
        if (Array.isArray(this.sharedWith)) {
            data["sharedWith"] = [];
            for (let item of this.sharedWith)
                data["sharedWith"].push(item ? item.toJSON() : undefined as any);
        }
        data["propertiesWithOverrideCount"] = this.propertiesWithOverrideCount;
        data["propertiesAssociatedCount"] = this.propertiesAssociatedCount;
        data["propertiesWithLogoCount"] = this.propertiesWithLogoCount;
        if (Array.isArray(this.ownPropertiesWithLogo)) {
            data["ownPropertiesWithLogo"] = [];
            for (let item of this.ownPropertiesWithLogo)
                data["ownPropertiesWithLogo"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomerLogoData {
    companyId?: number | undefined;
    companyName?: string;
    isCompanyDeleted?: boolean;
    isActive?: boolean;
    customerLogoId?: number | undefined;
    logoName?: string | undefined;
    bwofTemplateLogo?: string | undefined;
    isCompassDefault?: boolean;
    displayCompassLogo?: boolean;
    usedByOthersCount?: number;
    sharedWith?: LogoReference[];
    propertiesWithOverrideCount?: number;
    propertiesAssociatedCount?: number;
    propertiesWithLogoCount?: number;
    ownPropertiesWithLogo?: LogoReference[];
}

export class LogoReference implements ILogoReference {
    id?: number;
    name?: string;
    isProperty?: boolean;

    constructor(data?: ILogoReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isProperty = _data["isProperty"];
        }
    }

    static fromJS(data: any): LogoReference {
        data = typeof data === 'object' ? data : {};
        let result = new LogoReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isProperty"] = this.isProperty;
        return data;
    }
}

export interface ILogoReference {
    id?: number;
    name?: string;
    isProperty?: boolean;
}

export class CustomerLogoOption implements ICustomerLogoOption {
    customerLogoId?: number;
    logoName?: string | undefined;

    constructor(data?: ICustomerLogoOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerLogoId = _data["customerLogoId"];
            this.logoName = _data["logoName"];
        }
    }

    static fromJS(data: any): CustomerLogoOption {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLogoOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerLogoId"] = this.customerLogoId;
        data["logoName"] = this.logoName;
        return data;
    }
}

export interface ICustomerLogoOption {
    customerLogoId?: number;
    logoName?: string | undefined;
}

export abstract class BaseCommandOfBoolean implements IBaseCommandOfBoolean {

    constructor(data?: IBaseCommandOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseCommandOfBoolean {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfBoolean' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseCommandOfBoolean {
}

export class UpdateCompanyBwofTemplateLogoCommand extends BaseCommandOfBoolean implements IUpdateCompanyBwofTemplateLogoCommand {
    companyId?: number;
    bwofTemplateLogo?: string | undefined;

    constructor(data?: IUpdateCompanyBwofTemplateLogoCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.bwofTemplateLogo = _data["bwofTemplateLogo"];
        }
    }

    static override fromJS(data: any): UpdateCompanyBwofTemplateLogoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyBwofTemplateLogoCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["bwofTemplateLogo"] = this.bwofTemplateLogo;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCompanyBwofTemplateLogoCommand extends IBaseCommandOfBoolean {
    companyId?: number;
    bwofTemplateLogo?: string | undefined;
}

export class AssignCompanyBwofTemplateLogoCommand extends BaseCommandOfBoolean implements IAssignCompanyBwofTemplateLogoCommand {
    companyId?: number;
    customerLogoId?: number;

    constructor(data?: IAssignCompanyBwofTemplateLogoCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.customerLogoId = _data["customerLogoId"];
        }
    }

    static override fromJS(data: any): AssignCompanyBwofTemplateLogoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignCompanyBwofTemplateLogoCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["customerLogoId"] = this.customerLogoId;
        super.toJSON(data);
        return data;
    }
}

export interface IAssignCompanyBwofTemplateLogoCommand extends IBaseCommandOfBoolean {
    companyId?: number;
    customerLogoId?: number;
}

export class UpdateCustomerLogoCommand extends BaseCommandOfBoolean implements IUpdateCustomerLogoCommand {
    customerLogoId?: number;
    logoName?: string | undefined;
    deleteLogo?: boolean;

    constructor(data?: IUpdateCustomerLogoCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerLogoId = _data["customerLogoId"];
            this.logoName = _data["logoName"];
            this.deleteLogo = _data["deleteLogo"];
        }
    }

    static override fromJS(data: any): UpdateCustomerLogoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerLogoCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerLogoId"] = this.customerLogoId;
        data["logoName"] = this.logoName;
        data["deleteLogo"] = this.deleteLogo;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCustomerLogoCommand extends IBaseCommandOfBoolean {
    customerLogoId?: number;
    logoName?: string | undefined;
    deleteLogo?: boolean;
}

export class UpdateCompanyDisplayCompassLogoCommand extends BaseCommandOfBoolean implements IUpdateCompanyDisplayCompassLogoCommand {
    companyId?: number;
    displayCompassLogo?: boolean;

    constructor(data?: IUpdateCompanyDisplayCompassLogoCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.displayCompassLogo = _data["displayCompassLogo"];
        }
    }

    static override fromJS(data: any): UpdateCompanyDisplayCompassLogoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyDisplayCompassLogoCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["displayCompassLogo"] = this.displayCompassLogo;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCompanyDisplayCompassLogoCommand extends IBaseCommandOfBoolean {
    companyId?: number;
    displayCompassLogo?: boolean;
}

export abstract class BaseCommandOfInteger implements IBaseCommandOfInteger {

    constructor(data?: IBaseCommandOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseCommandOfInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseCommandOfInteger {
}

export class SyncPropertiesToCustomerLogoCommand extends BaseCommandOfInteger implements ISyncPropertiesToCustomerLogoCommand {
    companyId?: number;

    constructor(data?: ISyncPropertiesToCustomerLogoCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
        }
    }

    static override fromJS(data: any): SyncPropertiesToCustomerLogoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SyncPropertiesToCustomerLogoCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        super.toJSON(data);
        return data;
    }
}

export interface ISyncPropertiesToCustomerLogoCommand extends IBaseCommandOfInteger {
    companyId?: number;
}

export class PropertyLogoOverrideSummary implements IPropertyLogoOverrideSummary {
    propertyId?: number;
    propertyName?: string;
    streetAddress?: string | undefined;

    constructor(data?: IPropertyLogoOverrideSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.propertyName = _data["propertyName"];
            this.streetAddress = _data["streetAddress"];
        }
    }

    static fromJS(data: any): PropertyLogoOverrideSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyLogoOverrideSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["propertyName"] = this.propertyName;
        data["streetAddress"] = this.streetAddress;
        return data;
    }
}

export interface IPropertyLogoOverrideSummary {
    propertyId?: number;
    propertyName?: string;
    streetAddress?: string | undefined;
}

export class SyncAffectedPropertiesExcelExportRequest implements ISyncAffectedPropertiesExcelExportRequest {
    companyName?: string | undefined;
    records?: PropertyLogoOverrideSummary[];

    constructor(data?: ISyncAffectedPropertiesExcelExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(PropertyLogoOverrideSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncAffectedPropertiesExcelExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SyncAffectedPropertiesExcelExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISyncAffectedPropertiesExcelExportRequest {
    companyName?: string | undefined;
    records?: PropertyLogoOverrideSummary[];
}

export class PricingSummary implements IPricingSummary {
    company?: CompanyData | undefined;
    services?: PropertyServiceData[];

    constructor(data?: IPricingSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? CompanyData.fromJS(_data["company"]) : undefined as any;
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(PropertyServiceData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PricingSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PricingSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : undefined as any;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPricingSummary {
    company?: CompanyData | undefined;
    services?: PropertyServiceData[];
}

export class PropertyServiceData implements IPropertyServiceData {
    propertyServiceId?: number;
    serviceId?: number;
    parentServiceId?: number | undefined;
    propertyId?: number;
    propertyName?: string | undefined;
    buildingName?: string | undefined;
    active?: boolean;
    serviceName?: string | undefined;
    serviceType?: string;
    ref?: string | undefined;
    supplierCompanyId?: number | undefined;
    customerCompanyId?: number | undefined;
    supplierName?: string | undefined;
    whenNextServiceAnniversary?: Date | undefined;
    whenLastComplianceReceived?: Date | undefined;
    price?: number | undefined;
    intervalMonths?: number | undefined;
    adminNotes?: string | undefined;
    exceptionNotes?: string | undefined;
    whenLastSupplierEmailTriggered?: Date | undefined;
    whenLastSupplierEmailSent?: Date | undefined;
    whenSupplierEmailsSnoozedUntil?: Date | undefined;
    sort1?: number | undefined;
    sort2?: number | undefined;
    whenCreated?: Date | undefined;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;

    constructor(data?: IPropertyServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyServiceId = _data["propertyServiceId"];
            this.serviceId = _data["serviceId"];
            this.parentServiceId = _data["parentServiceId"];
            this.propertyId = _data["propertyId"];
            this.propertyName = _data["propertyName"];
            this.buildingName = _data["buildingName"];
            this.active = _data["active"];
            this.serviceName = _data["serviceName"];
            this.serviceType = _data["serviceType"];
            this.ref = _data["ref"];
            this.supplierCompanyId = _data["supplierCompanyId"];
            this.customerCompanyId = _data["customerCompanyId"];
            this.supplierName = _data["supplierName"];
            this.whenNextServiceAnniversary = _data["whenNextServiceAnniversary"] ? new Date(_data["whenNextServiceAnniversary"].toString()) : undefined as any;
            this.whenLastComplianceReceived = _data["whenLastComplianceReceived"] ? new Date(_data["whenLastComplianceReceived"].toString()) : undefined as any;
            this.price = _data["price"];
            this.intervalMonths = _data["intervalMonths"];
            this.adminNotes = _data["adminNotes"];
            this.exceptionNotes = _data["exceptionNotes"];
            this.whenLastSupplierEmailTriggered = _data["whenLastSupplierEmailTriggered"] ? new Date(_data["whenLastSupplierEmailTriggered"].toString()) : undefined as any;
            this.whenLastSupplierEmailSent = _data["whenLastSupplierEmailSent"] ? new Date(_data["whenLastSupplierEmailSent"].toString()) : undefined as any;
            this.whenSupplierEmailsSnoozedUntil = _data["whenSupplierEmailsSnoozedUntil"] ? new Date(_data["whenSupplierEmailsSnoozedUntil"].toString()) : undefined as any;
            this.sort1 = _data["sort1"];
            this.sort2 = _data["sort2"];
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : undefined as any;
            this.whenUpdated = _data["whenUpdated"] ? new Date(_data["whenUpdated"].toString()) : undefined as any;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PropertyServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyServiceId"] = this.propertyServiceId;
        data["serviceId"] = this.serviceId;
        data["parentServiceId"] = this.parentServiceId;
        data["propertyId"] = this.propertyId;
        data["propertyName"] = this.propertyName;
        data["buildingName"] = this.buildingName;
        data["active"] = this.active;
        data["serviceName"] = this.serviceName;
        data["serviceType"] = this.serviceType;
        data["ref"] = this.ref;
        data["supplierCompanyId"] = this.supplierCompanyId;
        data["customerCompanyId"] = this.customerCompanyId;
        data["supplierName"] = this.supplierName;
        data["whenNextServiceAnniversary"] = this.whenNextServiceAnniversary ? this.whenNextServiceAnniversary.toISOString() : undefined as any;
        data["whenLastComplianceReceived"] = this.whenLastComplianceReceived ? this.whenLastComplianceReceived.toISOString() : undefined as any;
        data["price"] = this.price;
        data["intervalMonths"] = this.intervalMonths;
        data["adminNotes"] = this.adminNotes;
        data["exceptionNotes"] = this.exceptionNotes;
        data["whenLastSupplierEmailTriggered"] = this.whenLastSupplierEmailTriggered ? this.whenLastSupplierEmailTriggered.toISOString() : undefined as any;
        data["whenLastSupplierEmailSent"] = this.whenLastSupplierEmailSent ? this.whenLastSupplierEmailSent.toISOString() : undefined as any;
        data["whenSupplierEmailsSnoozedUntil"] = this.whenSupplierEmailsSnoozedUntil ? this.whenSupplierEmailsSnoozedUntil.toISOString() : undefined as any;
        data["sort1"] = this.sort1;
        data["sort2"] = this.sort2;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : undefined as any;
        data["whenUpdated"] = this.whenUpdated ? this.whenUpdated.toISOString() : undefined as any;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : undefined as any;
        return data;
    }
}

export interface IPropertyServiceData {
    propertyServiceId?: number;
    serviceId?: number;
    parentServiceId?: number | undefined;
    propertyId?: number;
    propertyName?: string | undefined;
    buildingName?: string | undefined;
    active?: boolean;
    serviceName?: string | undefined;
    serviceType?: string;
    ref?: string | undefined;
    supplierCompanyId?: number | undefined;
    customerCompanyId?: number | undefined;
    supplierName?: string | undefined;
    whenNextServiceAnniversary?: Date | undefined;
    whenLastComplianceReceived?: Date | undefined;
    price?: number | undefined;
    intervalMonths?: number | undefined;
    adminNotes?: string | undefined;
    exceptionNotes?: string | undefined;
    whenLastSupplierEmailTriggered?: Date | undefined;
    whenLastSupplierEmailSent?: Date | undefined;
    whenSupplierEmailsSnoozedUntil?: Date | undefined;
    sort1?: number | undefined;
    sort2?: number | undefined;
    whenCreated?: Date | undefined;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;
}

export class CustomerLogosExcelExportRequest implements ICustomerLogosExcelExportRequest {
    includeDeleted?: boolean;
    includeUnassignedLogos?: boolean;
    records?: CustomerLogoData[] | undefined;

    constructor(data?: ICustomerLogosExcelExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeDeleted = _data["includeDeleted"];
            this.includeUnassignedLogos = _data["includeUnassignedLogos"];
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(CustomerLogoData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerLogosExcelExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLogosExcelExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeDeleted"] = this.includeDeleted;
        data["includeUnassignedLogos"] = this.includeUnassignedLogos;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomerLogosExcelExportRequest {
    includeDeleted?: boolean;
    includeUnassignedLogos?: boolean;
    records?: CustomerLogoData[] | undefined;
}

export abstract class BaseQueryOfListOfCompanySummary implements IBaseQueryOfListOfCompanySummary {

    constructor(data?: IBaseQueryOfListOfCompanySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseQueryOfListOfCompanySummary {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfListOfCompanySummary' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseQueryOfListOfCompanySummary {
}

export class GetFilteredCompanySummaryListQuery extends BaseQueryOfListOfCompanySummary implements IGetFilteredCompanySummaryListQuery {
    queryString?: string | undefined;
    recordLimit?: number | undefined;
    onlyActive?: boolean;
    includeCustomers?: boolean;
    includeSuppliers?: boolean;
    includeOwners?: boolean;
    includeAuthorities?: boolean;
    filterNorthIsland?: boolean;
    filterSouthIsland?: boolean;

    constructor(data?: IGetFilteredCompanySummaryListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.queryString = _data["queryString"];
            this.recordLimit = _data["recordLimit"];
            this.onlyActive = _data["onlyActive"];
            this.includeCustomers = _data["includeCustomers"];
            this.includeSuppliers = _data["includeSuppliers"];
            this.includeOwners = _data["includeOwners"];
            this.includeAuthorities = _data["includeAuthorities"];
            this.filterNorthIsland = _data["filterNorthIsland"];
            this.filterSouthIsland = _data["filterSouthIsland"];
        }
    }

    static override fromJS(data: any): GetFilteredCompanySummaryListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredCompanySummaryListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queryString"] = this.queryString;
        data["recordLimit"] = this.recordLimit;
        data["onlyActive"] = this.onlyActive;
        data["includeCustomers"] = this.includeCustomers;
        data["includeSuppliers"] = this.includeSuppliers;
        data["includeOwners"] = this.includeOwners;
        data["includeAuthorities"] = this.includeAuthorities;
        data["filterNorthIsland"] = this.filterNorthIsland;
        data["filterSouthIsland"] = this.filterSouthIsland;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFilteredCompanySummaryListQuery extends IBaseQueryOfListOfCompanySummary {
    queryString?: string | undefined;
    recordLimit?: number | undefined;
    onlyActive?: boolean;
    includeCustomers?: boolean;
    includeSuppliers?: boolean;
    includeOwners?: boolean;
    includeAuthorities?: boolean;
    filterNorthIsland?: boolean;
    filterSouthIsland?: boolean;
}

export class HashedPayloadOfICollectionOfContactListMember implements IHashedPayloadOfICollectionOfContactListMember {
    data?: ContactListMember[] | undefined;
    hash?: string;
    errorMessage?: string | undefined;

    constructor(data?: IHashedPayloadOfICollectionOfContactListMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ContactListMember.fromJS(item));
            }
            this.hash = _data["hash"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): HashedPayloadOfICollectionOfContactListMember {
        data = typeof data === 'object' ? data : {};
        let result = new HashedPayloadOfICollectionOfContactListMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["hash"] = this.hash;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IHashedPayloadOfICollectionOfContactListMember {
    data?: ContactListMember[] | undefined;
    hash?: string;
    errorMessage?: string | undefined;
}

export class ContactListMember implements IContactListMember {
    contactId?: number | undefined;
    companyId?: number | undefined;
    propertyId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    ddi?: string | undefined;
    companyName?: string | undefined;
    streetAddress?: string | undefined;
    postalAddress?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
    island?: string | undefined;
    accountNumber?: string | undefined;
    isCustomer?: boolean | undefined;
    isSupplier?: boolean | undefined;
    isAuthority?: boolean | undefined;
    isOwner?: boolean | undefined;
    isCompanyActive?: boolean;
    isCompanyDeleted?: boolean;
    isActive?: boolean;
    displayName?: string;

    constructor(data?: IContactListMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.companyId = _data["companyId"];
            this.propertyId = _data["propertyId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.jobTitle = _data["jobTitle"];
            this.email = _data["email"];
            this.mobile = _data["mobile"];
            this.ddi = _data["ddi"];
            this.companyName = _data["companyName"];
            this.streetAddress = _data["streetAddress"];
            this.postalAddress = _data["postalAddress"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.island = _data["island"];
            this.accountNumber = _data["accountNumber"];
            this.isCustomer = _data["isCustomer"];
            this.isSupplier = _data["isSupplier"];
            this.isAuthority = _data["isAuthority"];
            this.isOwner = _data["isOwner"];
            this.isCompanyActive = _data["isCompanyActive"];
            this.isCompanyDeleted = _data["isCompanyDeleted"];
            this.isActive = _data["isActive"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ContactListMember {
        data = typeof data === 'object' ? data : {};
        let result = new ContactListMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["companyId"] = this.companyId;
        data["propertyId"] = this.propertyId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["jobTitle"] = this.jobTitle;
        data["email"] = this.email;
        data["mobile"] = this.mobile;
        data["ddi"] = this.ddi;
        data["companyName"] = this.companyName;
        data["streetAddress"] = this.streetAddress;
        data["postalAddress"] = this.postalAddress;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["island"] = this.island;
        data["accountNumber"] = this.accountNumber;
        data["isCustomer"] = this.isCustomer;
        data["isSupplier"] = this.isSupplier;
        data["isAuthority"] = this.isAuthority;
        data["isOwner"] = this.isOwner;
        data["isCompanyActive"] = this.isCompanyActive;
        data["isCompanyDeleted"] = this.isCompanyDeleted;
        data["isActive"] = this.isActive;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IContactListMember {
    contactId?: number | undefined;
    companyId?: number | undefined;
    propertyId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    ddi?: string | undefined;
    companyName?: string | undefined;
    streetAddress?: string | undefined;
    postalAddress?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
    island?: string | undefined;
    accountNumber?: string | undefined;
    isCustomer?: boolean | undefined;
    isSupplier?: boolean | undefined;
    isAuthority?: boolean | undefined;
    isOwner?: boolean | undefined;
    isCompanyActive?: boolean;
    isCompanyDeleted?: boolean;
    isActive?: boolean;
    displayName?: string;
}

export abstract class BaseQueryOfICollectionOfContactListMember implements IBaseQueryOfICollectionOfContactListMember {

    constructor(data?: IBaseQueryOfICollectionOfContactListMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseQueryOfICollectionOfContactListMember {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfICollectionOfContactListMember' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseQueryOfICollectionOfContactListMember {
}

export class GetContactListQuery extends BaseQueryOfICollectionOfContactListMember implements IGetContactListQuery {
    query?: ContactListSearchQuery;

    constructor(data?: IGetContactListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.query = _data["query"] ? ContactListSearchQuery.fromJS(_data["query"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GetContactListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetContactListQuery extends IBaseQueryOfICollectionOfContactListMember {
    query?: ContactListSearchQuery;
}

export class ContactListSearchQuery implements IContactListSearchQuery {
    keywords?: string | undefined;
    island?: string | undefined;
    city?: string | undefined;
    ignoreDuplicateEmailAddresses?: boolean | undefined;
    includeCustomers?: boolean | undefined;
    includeSuppliers?: boolean | undefined;
    includeOwners?: boolean | undefined;
    includeSiteContacts?: boolean | undefined;
    includeInactive?: boolean | undefined;
    includeContactsWithoutEmail?: boolean | undefined;
    recordLimit?: number | undefined;

    constructor(data?: IContactListSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keywords = _data["keywords"];
            this.island = _data["island"];
            this.city = _data["city"];
            this.ignoreDuplicateEmailAddresses = _data["ignoreDuplicateEmailAddresses"];
            this.includeCustomers = _data["includeCustomers"];
            this.includeSuppliers = _data["includeSuppliers"];
            this.includeOwners = _data["includeOwners"];
            this.includeSiteContacts = _data["includeSiteContacts"];
            this.includeInactive = _data["includeInactive"];
            this.includeContactsWithoutEmail = _data["includeContactsWithoutEmail"];
            this.recordLimit = _data["recordLimit"];
        }
    }

    static fromJS(data: any): ContactListSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ContactListSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords;
        data["island"] = this.island;
        data["city"] = this.city;
        data["ignoreDuplicateEmailAddresses"] = this.ignoreDuplicateEmailAddresses;
        data["includeCustomers"] = this.includeCustomers;
        data["includeSuppliers"] = this.includeSuppliers;
        data["includeOwners"] = this.includeOwners;
        data["includeSiteContacts"] = this.includeSiteContacts;
        data["includeInactive"] = this.includeInactive;
        data["includeContactsWithoutEmail"] = this.includeContactsWithoutEmail;
        data["recordLimit"] = this.recordLimit;
        return data;
    }
}

export interface IContactListSearchQuery {
    keywords?: string | undefined;
    island?: string | undefined;
    city?: string | undefined;
    ignoreDuplicateEmailAddresses?: boolean | undefined;
    includeCustomers?: boolean | undefined;
    includeSuppliers?: boolean | undefined;
    includeOwners?: boolean | undefined;
    includeSiteContacts?: boolean | undefined;
    includeInactive?: boolean | undefined;
    includeContactsWithoutEmail?: boolean | undefined;
    recordLimit?: number | undefined;
}

export abstract class BaseQueryOfExcelDocument implements IBaseQueryOfExcelDocument {

    constructor(data?: IBaseQueryOfExcelDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseQueryOfExcelDocument {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfExcelDocument' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseQueryOfExcelDocument {
}

export class GetContactListExcelExportQuery extends BaseQueryOfExcelDocument implements IGetContactListExcelExportQuery {
    query?: ContactListSearchQuery;

    constructor(data?: IGetContactListExcelExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.query = _data["query"] ? ContactListSearchQuery.fromJS(_data["query"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GetContactListExcelExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactListExcelExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetContactListExcelExportQuery extends IBaseQueryOfExcelDocument {
    query?: ContactListSearchQuery;
}

export class RestoreContactCommand extends BaseCommandOfBoolean implements IRestoreContactCommand {
    contact?: ContactListMember;

    constructor(data?: IRestoreContactCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contact = _data["contact"] ? ContactListMember.fromJS(_data["contact"]) : undefined as any;
        }
    }

    static override fromJS(data: any): RestoreContactCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreContactCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreContactCommand extends IBaseCommandOfBoolean {
    contact?: ContactListMember;
}

export class ArchiveContactCommand extends BaseCommandOfBoolean implements IArchiveContactCommand {
    contact?: ContactListMember;

    constructor(data?: IArchiveContactCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contact = _data["contact"] ? ContactListMember.fromJS(_data["contact"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ArchiveContactCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveContactCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IArchiveContactCommand extends IBaseCommandOfBoolean {
    contact?: ContactListMember;
}

export class BulkUpdateContactsCommand extends BaseCommandOfBoolean implements IBulkUpdateContactsCommand {
    contact?: ContactListMember;

    constructor(data?: IBulkUpdateContactsCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contact = _data["contact"] ? ContactListMember.fromJS(_data["contact"]) : undefined as any;
        }
    }

    static override fromJS(data: any): BulkUpdateContactsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateContactsCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IBulkUpdateContactsCommand extends IBaseCommandOfBoolean {
    contact?: ContactListMember;
}

export abstract class BaseCommandOfListOfContactListMember implements IBaseCommandOfListOfContactListMember {

    constructor(data?: IBaseCommandOfListOfContactListMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseCommandOfListOfContactListMember {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfListOfContactListMember' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseCommandOfListOfContactListMember {
}

export class UpdateContactsCommand extends BaseCommandOfListOfContactListMember implements IUpdateContactsCommand {
    contacts?: ContactListMember[];

    constructor(data?: IUpdateContactsCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactListMember.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UpdateContactsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactsCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateContactsCommand extends IBaseCommandOfListOfContactListMember {
    contacts?: ContactListMember[];
}

export class ArchiveContactsCommand extends BaseCommandOfBoolean implements IArchiveContactsCommand {
    contact?: ContactListMember;

    constructor(data?: IArchiveContactsCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contact = _data["contact"] ? ContactListMember.fromJS(_data["contact"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ArchiveContactsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveContactsCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IArchiveContactsCommand extends IBaseCommandOfBoolean {
    contact?: ContactListMember;
}

export class RestoreContactsCommand extends BaseCommandOfBoolean implements IRestoreContactsCommand {
    contact?: ContactListMember;

    constructor(data?: IRestoreContactsCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contact = _data["contact"] ? ContactListMember.fromJS(_data["contact"]) : undefined as any;
        }
    }

    static override fromJS(data: any): RestoreContactsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreContactsCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreContactsCommand extends IBaseCommandOfBoolean {
    contact?: ContactListMember;
}

export class ReportContact implements IReportContact {
    name?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    signatureBase64?: string | undefined;

    constructor(data?: IReportContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.signatureBase64 = _data["signatureBase64"];
        }
    }

    static fromJS(data: any): ReportContact {
        data = typeof data === 'object' ? data : {};
        let result = new ReportContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["signatureBase64"] = this.signatureBase64;
        return data;
    }
}

export interface IReportContact {
    name?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    signatureBase64?: string | undefined;
}

export class DocumentData implements IDocumentData {
    documentId?: number;
    propertyId?: number;
    fileName?: string;
    referenceName?: string | undefined;
    documentDate?: Date | undefined;
    size?: number | undefined;
    active?: boolean;
    whenUploaded?: Date | undefined;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;

    constructor(data?: IDocumentData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.propertyId = _data["propertyId"];
            this.fileName = _data["fileName"];
            this.referenceName = _data["referenceName"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.size = _data["size"];
            this.active = _data["active"];
            this.whenUploaded = _data["whenUploaded"] ? new Date(_data["whenUploaded"].toString()) : undefined as any;
            this.whenUpdated = _data["whenUpdated"] ? new Date(_data["whenUpdated"].toString()) : undefined as any;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentData {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["propertyId"] = this.propertyId;
        data["fileName"] = this.fileName;
        data["referenceName"] = this.referenceName;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["size"] = this.size;
        data["active"] = this.active;
        data["whenUploaded"] = this.whenUploaded ? this.whenUploaded.toISOString() : undefined as any;
        data["whenUpdated"] = this.whenUpdated ? this.whenUpdated.toISOString() : undefined as any;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : undefined as any;
        return data;
    }
}

export interface IDocumentData {
    documentId?: number;
    propertyId?: number;
    fileName?: string;
    referenceName?: string | undefined;
    documentDate?: Date | undefined;
    size?: number | undefined;
    active?: boolean;
    whenUploaded?: Date | undefined;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;
}

export class GeneratePdfRequest implements IGeneratePdfRequest {
    propertyId?: number;
    documentHeader?: string | undefined;
    htmlContent?: string | undefined;
    filename?: string | undefined;
    fitToPageCount?: number | undefined;
    scalingPercentage?: number;

    constructor(data?: IGeneratePdfRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.documentHeader = _data["documentHeader"];
            this.htmlContent = _data["htmlContent"];
            this.filename = _data["filename"];
            this.fitToPageCount = _data["fitToPageCount"];
            this.scalingPercentage = _data["scalingPercentage"];
        }
    }

    static fromJS(data: any): GeneratePdfRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratePdfRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["documentHeader"] = this.documentHeader;
        data["htmlContent"] = this.htmlContent;
        data["filename"] = this.filename;
        data["fitToPageCount"] = this.fitToPageCount;
        data["scalingPercentage"] = this.scalingPercentage;
        return data;
    }
}

export interface IGeneratePdfRequest {
    propertyId?: number;
    documentHeader?: string | undefined;
    htmlContent?: string | undefined;
    filename?: string | undefined;
    fitToPageCount?: number | undefined;
    scalingPercentage?: number;
}

export class DownloadDocumentRequest implements IDownloadDocumentRequest {
    documentId?: number;
    inline?: boolean;

    constructor(data?: IDownloadDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.inline = _data["inline"];
        }
    }

    static fromJS(data: any): DownloadDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["inline"] = this.inline;
        return data;
    }
}

export interface IDownloadDocumentRequest {
    documentId?: number;
    inline?: boolean;
}

export class GetAutomationEmailResponseModel implements IGetAutomationEmailResponseModel {
    recommendedEmails?: AutomatedEmailData[];
    sentEmails?: AutomatedEmailData[];
    heldEmails?: AutomatedEmailData[];

    constructor(data?: IGetAutomationEmailResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recommendedEmails"])) {
                this.recommendedEmails = [] as any;
                for (let item of _data["recommendedEmails"])
                    this.recommendedEmails!.push(AutomatedEmailData.fromJS(item));
            }
            if (Array.isArray(_data["sentEmails"])) {
                this.sentEmails = [] as any;
                for (let item of _data["sentEmails"])
                    this.sentEmails!.push(AutomatedEmailData.fromJS(item));
            }
            if (Array.isArray(_data["heldEmails"])) {
                this.heldEmails = [] as any;
                for (let item of _data["heldEmails"])
                    this.heldEmails!.push(AutomatedEmailData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAutomationEmailResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAutomationEmailResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recommendedEmails)) {
            data["recommendedEmails"] = [];
            for (let item of this.recommendedEmails)
                data["recommendedEmails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sentEmails)) {
            data["sentEmails"] = [];
            for (let item of this.sentEmails)
                data["sentEmails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.heldEmails)) {
            data["heldEmails"] = [];
            for (let item of this.heldEmails)
                data["heldEmails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAutomationEmailResponseModel {
    recommendedEmails?: AutomatedEmailData[];
    sentEmails?: AutomatedEmailData[];
    heldEmails?: AutomatedEmailData[];
}

export class AutomatedEmailData implements IAutomatedEmailData {
    propertyId?: number;
    specificPropertyServiceID?: number | undefined;
    recipientCompanyId?: number | undefined;
    propertyName?: string;
    recipientCompanyName?: string | undefined;
    customerCompanyId?: number | undefined;
    customerCompanyName?: string | undefined;
    ccRecipients?: string | undefined;
    status?: string | undefined;
    generatedBy?: string | undefined;
    recipients?: string | undefined;
    reason?: string | undefined;
    emailContentTemplateName?: EmailTemplateType | undefined;
    nextDue?: Date | undefined;
    lstSupEmailTrg?: Date | undefined;
    lstSupEmailSent?: Date | undefined;
    snoozedTill?: Date | undefined;
    subServices?: EmailSubServiceData[];
    isSelectedOnRecommended?: boolean | undefined;
    isSelectedOnSnoozed?: boolean | undefined;

    constructor(data?: IAutomatedEmailData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.specificPropertyServiceID = _data["specificPropertyServiceID"];
            this.recipientCompanyId = _data["recipientCompanyId"];
            this.propertyName = _data["propertyName"];
            this.recipientCompanyName = _data["recipientCompanyName"];
            this.customerCompanyId = _data["customerCompanyId"];
            this.customerCompanyName = _data["customerCompanyName"];
            this.ccRecipients = _data["ccRecipients"];
            this.status = _data["status"];
            this.generatedBy = _data["generatedBy"];
            this.recipients = _data["recipients"];
            this.reason = _data["reason"];
            this.emailContentTemplateName = _data["emailContentTemplateName"];
            this.nextDue = _data["nextDue"] ? new Date(_data["nextDue"].toString()) : undefined as any;
            this.lstSupEmailTrg = _data["lstSupEmailTrg"] ? new Date(_data["lstSupEmailTrg"].toString()) : undefined as any;
            this.lstSupEmailSent = _data["lstSupEmailSent"] ? new Date(_data["lstSupEmailSent"].toString()) : undefined as any;
            this.snoozedTill = _data["snoozedTill"] ? new Date(_data["snoozedTill"].toString()) : undefined as any;
            if (Array.isArray(_data["subServices"])) {
                this.subServices = [] as any;
                for (let item of _data["subServices"])
                    this.subServices!.push(EmailSubServiceData.fromJS(item));
            }
            this.isSelectedOnRecommended = _data["isSelectedOnRecommended"];
            this.isSelectedOnSnoozed = _data["isSelectedOnSnoozed"];
        }
    }

    static fromJS(data: any): AutomatedEmailData {
        data = typeof data === 'object' ? data : {};
        let result = new AutomatedEmailData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["specificPropertyServiceID"] = this.specificPropertyServiceID;
        data["recipientCompanyId"] = this.recipientCompanyId;
        data["propertyName"] = this.propertyName;
        data["recipientCompanyName"] = this.recipientCompanyName;
        data["customerCompanyId"] = this.customerCompanyId;
        data["customerCompanyName"] = this.customerCompanyName;
        data["ccRecipients"] = this.ccRecipients;
        data["status"] = this.status;
        data["generatedBy"] = this.generatedBy;
        data["recipients"] = this.recipients;
        data["reason"] = this.reason;
        data["emailContentTemplateName"] = this.emailContentTemplateName;
        data["nextDue"] = this.nextDue ? this.nextDue.toISOString() : undefined as any;
        data["lstSupEmailTrg"] = this.lstSupEmailTrg ? this.lstSupEmailTrg.toISOString() : undefined as any;
        data["lstSupEmailSent"] = this.lstSupEmailSent ? this.lstSupEmailSent.toISOString() : undefined as any;
        data["snoozedTill"] = this.snoozedTill ? this.snoozedTill.toISOString() : undefined as any;
        if (Array.isArray(this.subServices)) {
            data["subServices"] = [];
            for (let item of this.subServices)
                data["subServices"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSelectedOnRecommended"] = this.isSelectedOnRecommended;
        data["isSelectedOnSnoozed"] = this.isSelectedOnSnoozed;
        return data;
    }
}

export interface IAutomatedEmailData {
    propertyId?: number;
    specificPropertyServiceID?: number | undefined;
    recipientCompanyId?: number | undefined;
    propertyName?: string;
    recipientCompanyName?: string | undefined;
    customerCompanyId?: number | undefined;
    customerCompanyName?: string | undefined;
    ccRecipients?: string | undefined;
    status?: string | undefined;
    generatedBy?: string | undefined;
    recipients?: string | undefined;
    reason?: string | undefined;
    emailContentTemplateName?: EmailTemplateType | undefined;
    nextDue?: Date | undefined;
    lstSupEmailTrg?: Date | undefined;
    lstSupEmailSent?: Date | undefined;
    snoozedTill?: Date | undefined;
    subServices?: EmailSubServiceData[];
    isSelectedOnRecommended?: boolean | undefined;
    isSelectedOnSnoozed?: boolean | undefined;
}

export enum EmailTemplateType {
    Email_Auto_12A = 100,
    Email_12A_Request = 101,
    Email_12A_FollowUp = 102,
    Email_12A_Urgent = 103,
    Email_12A_Overdue = 104,
    Email_Auto_TrialEvac = 200,
    Email_TrialEvac_Audit_Request = 201,
    Email_TrialEvac_Audit_Overdue = 202,
    Email_TrialEvac_FullService_Request = 203,
    Email_TrialEvac_FullService_FollowUp = 204,
    Email_TrialEvac_FullService_Overdue = 205,
    Email_AuthorityOverdueBwofNotification = 300,
    Email_Bwof_Audit = 301,
}

export class EmailSubServiceData implements IEmailSubServiceData {
    propertyServiceId?: number;
    propertyId?: number;
    supplierId?: number | undefined;
    subServiceSupplierName?: string | undefined;
    serviceName?: string | undefined;
    lstSubSrvCompRec?: Date | undefined;
    nextSubSrvAniv?: Date | undefined;
    exceptionNotes?: string | undefined;
    recipients?: string | undefined;
    lstSupEmailTrg?: Date | undefined;
    lstSupEmailSent?: Date | undefined;
    snoozedTill?: Date | undefined;

    constructor(data?: IEmailSubServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyServiceId = _data["propertyServiceId"];
            this.propertyId = _data["propertyId"];
            this.supplierId = _data["supplierId"];
            this.subServiceSupplierName = _data["subServiceSupplierName"];
            this.serviceName = _data["serviceName"];
            this.lstSubSrvCompRec = _data["lstSubSrvCompRec"] ? new Date(_data["lstSubSrvCompRec"].toString()) : undefined as any;
            this.nextSubSrvAniv = _data["nextSubSrvAniv"] ? new Date(_data["nextSubSrvAniv"].toString()) : undefined as any;
            this.exceptionNotes = _data["exceptionNotes"];
            this.recipients = _data["recipients"];
            this.lstSupEmailTrg = _data["lstSupEmailTrg"] ? new Date(_data["lstSupEmailTrg"].toString()) : undefined as any;
            this.lstSupEmailSent = _data["lstSupEmailSent"] ? new Date(_data["lstSupEmailSent"].toString()) : undefined as any;
            this.snoozedTill = _data["snoozedTill"] ? new Date(_data["snoozedTill"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EmailSubServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSubServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyServiceId"] = this.propertyServiceId;
        data["propertyId"] = this.propertyId;
        data["supplierId"] = this.supplierId;
        data["subServiceSupplierName"] = this.subServiceSupplierName;
        data["serviceName"] = this.serviceName;
        data["lstSubSrvCompRec"] = this.lstSubSrvCompRec ? this.lstSubSrvCompRec.toISOString() : undefined as any;
        data["nextSubSrvAniv"] = this.nextSubSrvAniv ? this.nextSubSrvAniv.toISOString() : undefined as any;
        data["exceptionNotes"] = this.exceptionNotes;
        data["recipients"] = this.recipients;
        data["lstSupEmailTrg"] = this.lstSupEmailTrg ? this.lstSupEmailTrg.toISOString() : undefined as any;
        data["lstSupEmailSent"] = this.lstSupEmailSent ? this.lstSupEmailSent.toISOString() : undefined as any;
        data["snoozedTill"] = this.snoozedTill ? this.snoozedTill.toISOString() : undefined as any;
        return data;
    }
}

export interface IEmailSubServiceData {
    propertyServiceId?: number;
    propertyId?: number;
    supplierId?: number | undefined;
    subServiceSupplierName?: string | undefined;
    serviceName?: string | undefined;
    lstSubSrvCompRec?: Date | undefined;
    nextSubSrvAniv?: Date | undefined;
    exceptionNotes?: string | undefined;
    recipients?: string | undefined;
    lstSupEmailTrg?: Date | undefined;
    lstSupEmailSent?: Date | undefined;
    snoozedTill?: Date | undefined;
}

export class SendSnoozeEmailsRequest implements ISendSnoozeEmailsRequest {
    numberOfDays?: number | undefined;
    propertyServiceIdList?: number[];
    authorityPropertyIdList?: number[];
    isBwofEmail?: boolean | undefined;

    constructor(data?: ISendSnoozeEmailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfDays = _data["numberOfDays"];
            if (Array.isArray(_data["propertyServiceIdList"])) {
                this.propertyServiceIdList = [] as any;
                for (let item of _data["propertyServiceIdList"])
                    this.propertyServiceIdList!.push(item);
            }
            if (Array.isArray(_data["authorityPropertyIdList"])) {
                this.authorityPropertyIdList = [] as any;
                for (let item of _data["authorityPropertyIdList"])
                    this.authorityPropertyIdList!.push(item);
            }
            this.isBwofEmail = _data["isBwofEmail"];
        }
    }

    static fromJS(data: any): SendSnoozeEmailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendSnoozeEmailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfDays"] = this.numberOfDays;
        if (Array.isArray(this.propertyServiceIdList)) {
            data["propertyServiceIdList"] = [];
            for (let item of this.propertyServiceIdList)
                data["propertyServiceIdList"].push(item);
        }
        if (Array.isArray(this.authorityPropertyIdList)) {
            data["authorityPropertyIdList"] = [];
            for (let item of this.authorityPropertyIdList)
                data["authorityPropertyIdList"].push(item);
        }
        data["isBwofEmail"] = this.isBwofEmail;
        return data;
    }
}

export interface ISendSnoozeEmailsRequest {
    numberOfDays?: number | undefined;
    propertyServiceIdList?: number[];
    authorityPropertyIdList?: number[];
    isBwofEmail?: boolean | undefined;
}

export class GetRenderedEmailTemplateResponse implements IGetRenderedEmailTemplateResponse {
    recipients?: ContactData[];
    ccRecipients?: ContactData[];
    subject?: string;
    attachedFiles?: string[];
    renderedEmailContent?: string;
    emailContentTemplate?: EmailTemplateType;
    hasServices?: boolean;

    constructor(data?: IGetRenderedEmailTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(ContactData.fromJS(item));
            }
            if (Array.isArray(_data["ccRecipients"])) {
                this.ccRecipients = [] as any;
                for (let item of _data["ccRecipients"])
                    this.ccRecipients!.push(ContactData.fromJS(item));
            }
            this.subject = _data["subject"];
            if (Array.isArray(_data["attachedFiles"])) {
                this.attachedFiles = [] as any;
                for (let item of _data["attachedFiles"])
                    this.attachedFiles!.push(item);
            }
            this.renderedEmailContent = _data["renderedEmailContent"];
            this.emailContentTemplate = _data["emailContentTemplate"];
            this.hasServices = _data["hasServices"];
        }
    }

    static fromJS(data: any): GetRenderedEmailTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRenderedEmailTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ccRecipients)) {
            data["ccRecipients"] = [];
            for (let item of this.ccRecipients)
                data["ccRecipients"].push(item ? item.toJSON() : undefined as any);
        }
        data["subject"] = this.subject;
        if (Array.isArray(this.attachedFiles)) {
            data["attachedFiles"] = [];
            for (let item of this.attachedFiles)
                data["attachedFiles"].push(item);
        }
        data["renderedEmailContent"] = this.renderedEmailContent;
        data["emailContentTemplate"] = this.emailContentTemplate;
        data["hasServices"] = this.hasServices;
        return data;
    }
}

export interface IGetRenderedEmailTemplateResponse {
    recipients?: ContactData[];
    ccRecipients?: ContactData[];
    subject?: string;
    attachedFiles?: string[];
    renderedEmailContent?: string;
    emailContentTemplate?: EmailTemplateType;
    hasServices?: boolean;
}

export abstract class BaseQueryOfGetRenderedEmailTemplateResponse implements IBaseQueryOfGetRenderedEmailTemplateResponse {

    constructor(data?: IBaseQueryOfGetRenderedEmailTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseQueryOfGetRenderedEmailTemplateResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetRenderedEmailTemplateResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseQueryOfGetRenderedEmailTemplateResponse {
}

export class GetRenderedEmailTemplateQuery extends BaseQueryOfGetRenderedEmailTemplateResponse implements IGetRenderedEmailTemplateQuery {
    propertyId?: number;
    recipientCompanyId?: number;
    emailBodyTemplateName?: EmailTemplateType | undefined;
    triggeredByPropertyServiceID?: number | undefined;

    constructor(data?: IGetRenderedEmailTemplateQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.recipientCompanyId = _data["recipientCompanyId"];
            this.emailBodyTemplateName = _data["emailBodyTemplateName"];
            this.triggeredByPropertyServiceID = _data["triggeredByPropertyServiceID"];
        }
    }

    static override fromJS(data: any): GetRenderedEmailTemplateQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRenderedEmailTemplateQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["recipientCompanyId"] = this.recipientCompanyId;
        data["emailBodyTemplateName"] = this.emailBodyTemplateName;
        data["triggeredByPropertyServiceID"] = this.triggeredByPropertyServiceID;
        super.toJSON(data);
        return data;
    }
}

export interface IGetRenderedEmailTemplateQuery extends IBaseQueryOfGetRenderedEmailTemplateResponse {
    propertyId?: number;
    recipientCompanyId?: number;
    emailBodyTemplateName?: EmailTemplateType | undefined;
    triggeredByPropertyServiceID?: number | undefined;
}

export class GenerateAndSendEmailCommand extends BaseCommandOfBoolean implements IGenerateAndSendEmailCommand {
    propertyId?: number;
    recipientCompanyId?: number;
    recipients?: ContactData[];
    ccRecipients?: ContactData[] | undefined;
    emailSubject?: string;
    emailContent?: string;
    emailContentTemplate?: EmailTemplateType;
    issuedDate?: Date | undefined;
    propertyServiceId?: number | undefined;

    constructor(data?: IGenerateAndSendEmailCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.recipientCompanyId = _data["recipientCompanyId"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(ContactData.fromJS(item));
            }
            if (Array.isArray(_data["ccRecipients"])) {
                this.ccRecipients = [] as any;
                for (let item of _data["ccRecipients"])
                    this.ccRecipients!.push(ContactData.fromJS(item));
            }
            this.emailSubject = _data["emailSubject"];
            this.emailContent = _data["emailContent"];
            this.emailContentTemplate = _data["emailContentTemplate"];
            this.issuedDate = _data["issuedDate"] ? new Date(_data["issuedDate"].toString()) : undefined as any;
            this.propertyServiceId = _data["propertyServiceId"];
        }
    }

    static override fromJS(data: any): GenerateAndSendEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateAndSendEmailCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["recipientCompanyId"] = this.recipientCompanyId;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ccRecipients)) {
            data["ccRecipients"] = [];
            for (let item of this.ccRecipients)
                data["ccRecipients"].push(item ? item.toJSON() : undefined as any);
        }
        data["emailSubject"] = this.emailSubject;
        data["emailContent"] = this.emailContent;
        data["emailContentTemplate"] = this.emailContentTemplate;
        data["issuedDate"] = this.issuedDate ? this.issuedDate.toISOString() : undefined as any;
        data["propertyServiceId"] = this.propertyServiceId;
        super.toJSON(data);
        return data;
    }
}

export interface IGenerateAndSendEmailCommand extends IBaseCommandOfBoolean {
    propertyId?: number;
    recipientCompanyId?: number;
    recipients?: ContactData[];
    ccRecipients?: ContactData[] | undefined;
    emailSubject?: string;
    emailContent?: string;
    emailContentTemplate?: EmailTemplateType;
    issuedDate?: Date | undefined;
    propertyServiceId?: number | undefined;
}

export class HashedPayloadOfListOfPropertySummary implements IHashedPayloadOfListOfPropertySummary {
    data?: PropertySummary[] | undefined;
    hash?: string;
    errorMessage?: string | undefined;

    constructor(data?: IHashedPayloadOfListOfPropertySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PropertySummary.fromJS(item));
            }
            this.hash = _data["hash"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): HashedPayloadOfListOfPropertySummary {
        data = typeof data === 'object' ? data : {};
        let result = new HashedPayloadOfListOfPropertySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["hash"] = this.hash;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IHashedPayloadOfListOfPropertySummary {
    data?: PropertySummary[] | undefined;
    hash?: string;
    errorMessage?: string | undefined;
}

export class PropertyDashboardData implements IPropertyDashboardData {
    propertyId?: number;
    propertyNameAndLocation?: string;
    customerPropertyRef?: string | undefined;
    propertyName?: string;
    streetAddress?: string | undefined;
    custId?: number | undefined;
    customerName?: string | undefined;
    location?: string | undefined;
    propertyServiceId?: number | undefined;
    serviceId?: number | undefined;
    serviceName?: string | undefined;
    serviceType?: string | undefined;
    suppId?: number | undefined;
    propertyServiceRef?: string | undefined;
    supplierName?: string | undefined;
    newPreviousDate?: Date | undefined;
    lastDue?: Date | undefined;
    due?: Date | undefined;
    days?: number | undefined;
    propertyActive?: boolean;
    serviceActive?: boolean | undefined;
    exceptionNotes?: string | undefined;
    readyBwofSubServices?: number | undefined;
    totalBwofSubServices?: number | undefined;
    billingEntityName?: string | undefined;
    billingEntityAccountNumber?: string | undefined;
    bwofDue?: Date | undefined;

    constructor(data?: IPropertyDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.propertyNameAndLocation = _data["propertyNameAndLocation"];
            this.customerPropertyRef = _data["customerPropertyRef"];
            this.propertyName = _data["propertyName"];
            this.streetAddress = _data["streetAddress"];
            this.custId = _data["custId"];
            this.customerName = _data["customerName"];
            this.location = _data["location"];
            this.propertyServiceId = _data["propertyServiceId"];
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.serviceType = _data["serviceType"];
            this.suppId = _data["suppId"];
            this.propertyServiceRef = _data["propertyServiceRef"];
            this.supplierName = _data["supplierName"];
            this.newPreviousDate = _data["newPreviousDate"] ? new Date(_data["newPreviousDate"].toString()) : undefined as any;
            this.lastDue = _data["lastDue"] ? new Date(_data["lastDue"].toString()) : undefined as any;
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.days = _data["days"];
            this.propertyActive = _data["propertyActive"];
            this.serviceActive = _data["serviceActive"];
            this.exceptionNotes = _data["exceptionNotes"];
            this.readyBwofSubServices = _data["readyBwofSubServices"];
            this.totalBwofSubServices = _data["totalBwofSubServices"];
            this.billingEntityName = _data["billingEntityName"];
            this.billingEntityAccountNumber = _data["billingEntityAccountNumber"];
            this.bwofDue = _data["bwofDue"] ? new Date(_data["bwofDue"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PropertyDashboardData {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["propertyNameAndLocation"] = this.propertyNameAndLocation;
        data["customerPropertyRef"] = this.customerPropertyRef;
        data["propertyName"] = this.propertyName;
        data["streetAddress"] = this.streetAddress;
        data["custId"] = this.custId;
        data["customerName"] = this.customerName;
        data["location"] = this.location;
        data["propertyServiceId"] = this.propertyServiceId;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["serviceType"] = this.serviceType;
        data["suppId"] = this.suppId;
        data["propertyServiceRef"] = this.propertyServiceRef;
        data["supplierName"] = this.supplierName;
        data["newPreviousDate"] = this.newPreviousDate ? this.newPreviousDate.toISOString() : undefined as any;
        data["lastDue"] = this.lastDue ? this.lastDue.toISOString() : undefined as any;
        data["due"] = this.due ? this.due.toISOString() : undefined as any;
        data["days"] = this.days;
        data["propertyActive"] = this.propertyActive;
        data["serviceActive"] = this.serviceActive;
        data["exceptionNotes"] = this.exceptionNotes;
        data["readyBwofSubServices"] = this.readyBwofSubServices;
        data["totalBwofSubServices"] = this.totalBwofSubServices;
        data["billingEntityName"] = this.billingEntityName;
        data["billingEntityAccountNumber"] = this.billingEntityAccountNumber;
        data["bwofDue"] = this.bwofDue ? this.bwofDue.toISOString() : undefined as any;
        return data;
    }
}

export interface IPropertyDashboardData {
    propertyId?: number;
    propertyNameAndLocation?: string;
    customerPropertyRef?: string | undefined;
    propertyName?: string;
    streetAddress?: string | undefined;
    custId?: number | undefined;
    customerName?: string | undefined;
    location?: string | undefined;
    propertyServiceId?: number | undefined;
    serviceId?: number | undefined;
    serviceName?: string | undefined;
    serviceType?: string | undefined;
    suppId?: number | undefined;
    propertyServiceRef?: string | undefined;
    supplierName?: string | undefined;
    newPreviousDate?: Date | undefined;
    lastDue?: Date | undefined;
    due?: Date | undefined;
    days?: number | undefined;
    propertyActive?: boolean;
    serviceActive?: boolean | undefined;
    exceptionNotes?: string | undefined;
    readyBwofSubServices?: number | undefined;
    totalBwofSubServices?: number | undefined;
    billingEntityName?: string | undefined;
    billingEntityAccountNumber?: string | undefined;
    bwofDue?: Date | undefined;
}

export abstract class BaseQueryOfListOfPropertyDashboardData implements IBaseQueryOfListOfPropertyDashboardData {

    constructor(data?: IBaseQueryOfListOfPropertyDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseQueryOfListOfPropertyDashboardData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfListOfPropertyDashboardData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseQueryOfListOfPropertyDashboardData {
}

export class GetPropertyDashboardQuery extends BaseQueryOfListOfPropertyDashboardData implements IGetPropertyDashboardQuery {
    queryString?: string | undefined;
    serviceId?: number | undefined;
    activeProperty?: boolean;
    activeService?: boolean;
    readyToIssue?: boolean;
    includeSubServices?: boolean;
    includeBwofAnniversary?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IGetPropertyDashboardQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.queryString = _data["queryString"];
            this.serviceId = _data["serviceId"];
            this.activeProperty = _data["activeProperty"];
            this.activeService = _data["activeService"];
            this.readyToIssue = _data["readyToIssue"];
            this.includeSubServices = _data["includeSubServices"];
            this.includeBwofAnniversary = _data["includeBwofAnniversary"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): GetPropertyDashboardQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertyDashboardQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queryString"] = this.queryString;
        data["serviceId"] = this.serviceId;
        data["activeProperty"] = this.activeProperty;
        data["activeService"] = this.activeService;
        data["readyToIssue"] = this.readyToIssue;
        data["includeSubServices"] = this.includeSubServices;
        data["includeBwofAnniversary"] = this.includeBwofAnniversary;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPropertyDashboardQuery extends IBaseQueryOfListOfPropertyDashboardData {
    queryString?: string | undefined;
    serviceId?: number | undefined;
    activeProperty?: boolean;
    activeService?: boolean;
    readyToIssue?: boolean;
    includeSubServices?: boolean;
    includeBwofAnniversary?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class UpdatePropertyServiceDatesCommand extends BaseCommandOfBoolean implements IUpdatePropertyServiceDatesCommand {
    propertyServiceId?: number;
    newPreviousDate?: Date | undefined;

    constructor(data?: IUpdatePropertyServiceDatesCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyServiceId = _data["propertyServiceId"];
            this.newPreviousDate = _data["newPreviousDate"] ? new Date(_data["newPreviousDate"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): UpdatePropertyServiceDatesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePropertyServiceDatesCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyServiceId"] = this.propertyServiceId;
        data["newPreviousDate"] = this.newPreviousDate ? this.newPreviousDate.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePropertyServiceDatesCommand extends IBaseCommandOfBoolean {
    propertyServiceId?: number;
    newPreviousDate?: Date | undefined;
}

export class PropertyData implements IPropertyData {
    propertyId?: number;
    ownerId?: number | undefined;
    propertyName?: string;
    regionalAuthorityCompanyId?: number | undefined;
    customerCompanyId?: number | undefined;
    billingEntityCompanyId?: number | undefined;
    billingEntityId?: number | undefined;
    buildingName?: string | undefined;
    streetAddress?: string;
    suburb?: string | undefined;
    city?: string | undefined;
    postcode?: string | undefined;
    propertyNotes?: string | undefined;
    documentDirectory?: string | undefined;
    customerPropertyRef?: string | undefined;
    whenCreated?: Date | undefined;
    active?: boolean;
    enableEmailAutomation?: boolean;
    whenFirstDocumentUploaded?: Date | undefined;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;
    bwofLogoId?: number | undefined;
    propertyBwof?: PropertyBwofData | undefined;
    propertyEvacuation?: PropertyEvacuationData | undefined;
    owner?: CompanyData | undefined;
    customerBwofTemplateLogo?: string | undefined;
    displayCompassLogo?: boolean;
    billingEntity?: BillingEntityData | undefined;
    services?: PropertyServiceData[];
    siteContacts?: ContactData[];
    ownerContacts?: ContactData[];
    documents?: DocumentData[];

    constructor(data?: IPropertyData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.ownerId = _data["ownerId"];
            this.propertyName = _data["propertyName"];
            this.regionalAuthorityCompanyId = _data["regionalAuthorityCompanyId"];
            this.customerCompanyId = _data["customerCompanyId"];
            this.billingEntityCompanyId = _data["billingEntityCompanyId"];
            this.billingEntityId = _data["billingEntityId"];
            this.buildingName = _data["buildingName"];
            this.streetAddress = _data["streetAddress"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.postcode = _data["postcode"];
            this.propertyNotes = _data["propertyNotes"];
            this.documentDirectory = _data["documentDirectory"];
            this.customerPropertyRef = _data["customerPropertyRef"];
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : undefined as any;
            this.active = _data["active"];
            this.enableEmailAutomation = _data["enableEmailAutomation"];
            this.whenFirstDocumentUploaded = _data["whenFirstDocumentUploaded"] ? new Date(_data["whenFirstDocumentUploaded"].toString()) : undefined as any;
            this.whenUpdated = _data["whenUpdated"] ? new Date(_data["whenUpdated"].toString()) : undefined as any;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : undefined as any;
            this.bwofLogoId = _data["bwofLogoId"];
            this.propertyBwof = _data["propertyBwof"] ? PropertyBwofData.fromJS(_data["propertyBwof"]) : undefined as any;
            this.propertyEvacuation = _data["propertyEvacuation"] ? PropertyEvacuationData.fromJS(_data["propertyEvacuation"]) : undefined as any;
            this.owner = _data["owner"] ? CompanyData.fromJS(_data["owner"]) : undefined as any;
            this.customerBwofTemplateLogo = _data["customerBwofTemplateLogo"];
            this.displayCompassLogo = _data["displayCompassLogo"];
            this.billingEntity = _data["billingEntity"] ? BillingEntityData.fromJS(_data["billingEntity"]) : undefined as any;
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(PropertyServiceData.fromJS(item));
            }
            if (Array.isArray(_data["siteContacts"])) {
                this.siteContacts = [] as any;
                for (let item of _data["siteContacts"])
                    this.siteContacts!.push(ContactData.fromJS(item));
            }
            if (Array.isArray(_data["ownerContacts"])) {
                this.ownerContacts = [] as any;
                for (let item of _data["ownerContacts"])
                    this.ownerContacts!.push(ContactData.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyData {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["ownerId"] = this.ownerId;
        data["propertyName"] = this.propertyName;
        data["regionalAuthorityCompanyId"] = this.regionalAuthorityCompanyId;
        data["customerCompanyId"] = this.customerCompanyId;
        data["billingEntityCompanyId"] = this.billingEntityCompanyId;
        data["billingEntityId"] = this.billingEntityId;
        data["buildingName"] = this.buildingName;
        data["streetAddress"] = this.streetAddress;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["postcode"] = this.postcode;
        data["propertyNotes"] = this.propertyNotes;
        data["documentDirectory"] = this.documentDirectory;
        data["customerPropertyRef"] = this.customerPropertyRef;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : undefined as any;
        data["active"] = this.active;
        data["enableEmailAutomation"] = this.enableEmailAutomation;
        data["whenFirstDocumentUploaded"] = this.whenFirstDocumentUploaded ? this.whenFirstDocumentUploaded.toISOString() : undefined as any;
        data["whenUpdated"] = this.whenUpdated ? this.whenUpdated.toISOString() : undefined as any;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : undefined as any;
        data["bwofLogoId"] = this.bwofLogoId;
        data["propertyBwof"] = this.propertyBwof ? this.propertyBwof.toJSON() : undefined as any;
        data["propertyEvacuation"] = this.propertyEvacuation ? this.propertyEvacuation.toJSON() : undefined as any;
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["customerBwofTemplateLogo"] = this.customerBwofTemplateLogo;
        data["displayCompassLogo"] = this.displayCompassLogo;
        data["billingEntity"] = this.billingEntity ? this.billingEntity.toJSON() : undefined as any;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.siteContacts)) {
            data["siteContacts"] = [];
            for (let item of this.siteContacts)
                data["siteContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ownerContacts)) {
            data["ownerContacts"] = [];
            for (let item of this.ownerContacts)
                data["ownerContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPropertyData {
    propertyId?: number;
    ownerId?: number | undefined;
    propertyName?: string;
    regionalAuthorityCompanyId?: number | undefined;
    customerCompanyId?: number | undefined;
    billingEntityCompanyId?: number | undefined;
    billingEntityId?: number | undefined;
    buildingName?: string | undefined;
    streetAddress?: string;
    suburb?: string | undefined;
    city?: string | undefined;
    postcode?: string | undefined;
    propertyNotes?: string | undefined;
    documentDirectory?: string | undefined;
    customerPropertyRef?: string | undefined;
    whenCreated?: Date | undefined;
    active?: boolean;
    enableEmailAutomation?: boolean;
    whenFirstDocumentUploaded?: Date | undefined;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;
    bwofLogoId?: number | undefined;
    propertyBwof?: PropertyBwofData | undefined;
    propertyEvacuation?: PropertyEvacuationData | undefined;
    owner?: CompanyData | undefined;
    customerBwofTemplateLogo?: string | undefined;
    displayCompassLogo?: boolean;
    billingEntity?: BillingEntityData | undefined;
    services?: PropertyServiceData[];
    siteContacts?: ContactData[];
    ownerContacts?: ContactData[];
    documents?: DocumentData[];
}

export class PropertyBwofData implements IPropertyBwofData {
    propertyId?: number;
    ownerContactId?: number | undefined;
    bwofIssuedBy?: string | undefined;
    complianceScheduleMonths?: number | undefined;
    bwofLocated?: string | undefined;
    buildingSafetyManualLocated?: string | undefined;
    buildingSafetyManualIssuedOrUpdated?: Date | undefined;
    complianceSchedule?: string | undefined;
    complianceScheduleOnFile?: boolean;
    buildingConsent?: string | undefined;
    codeComplianceCertificate?: string | undefined;
    fireReportOnFile?: boolean;
    ownerInspectionsCompletedBy?: string | undefined;
    compassDoTestingOrMaintenance?: boolean;
    legalDescription?: string | undefined;
    locationOfBuildingWithinSite?: string | undefined;
    buildingUse?: string | undefined;
    purposeGroup?: string | undefined;
    highestFireHazardCategoryFhcNumber?: string | undefined;
    maximumNumberOfOccupants?: string | undefined;
    levelUnitNo?: string | undefined;
    firstConstructed?: string | undefined;
    intendedLifeOfTheBuilding?: string | undefined;
    issuedBy?: string | undefined;
    bwofIssuedDate?: Date | undefined;
    whenCreated?: Date | undefined;
    whenUpdated?: Date | undefined;
    ownerContact?: ContactData | undefined;

    constructor(data?: IPropertyBwofData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.ownerContactId = _data["ownerContactId"];
            this.bwofIssuedBy = _data["bwofIssuedBy"];
            this.complianceScheduleMonths = _data["complianceScheduleMonths"];
            this.bwofLocated = _data["bwofLocated"];
            this.buildingSafetyManualLocated = _data["buildingSafetyManualLocated"];
            this.buildingSafetyManualIssuedOrUpdated = _data["buildingSafetyManualIssuedOrUpdated"] ? new Date(_data["buildingSafetyManualIssuedOrUpdated"].toString()) : undefined as any;
            this.complianceSchedule = _data["complianceSchedule"];
            this.complianceScheduleOnFile = _data["complianceScheduleOnFile"];
            this.buildingConsent = _data["buildingConsent"];
            this.codeComplianceCertificate = _data["codeComplianceCertificate"];
            this.fireReportOnFile = _data["fireReportOnFile"];
            this.ownerInspectionsCompletedBy = _data["ownerInspectionsCompletedBy"];
            this.compassDoTestingOrMaintenance = _data["compassDoTestingOrMaintenance"];
            this.legalDescription = _data["legalDescription"];
            this.locationOfBuildingWithinSite = _data["locationOfBuildingWithinSite"];
            this.buildingUse = _data["buildingUse"];
            this.purposeGroup = _data["purposeGroup"];
            this.highestFireHazardCategoryFhcNumber = _data["highestFireHazardCategoryFhcNumber"];
            this.maximumNumberOfOccupants = _data["maximumNumberOfOccupants"];
            this.levelUnitNo = _data["levelUnitNo"];
            this.firstConstructed = _data["firstConstructed"];
            this.intendedLifeOfTheBuilding = _data["intendedLifeOfTheBuilding"];
            this.issuedBy = _data["issuedBy"];
            this.bwofIssuedDate = _data["bwofIssuedDate"] ? new Date(_data["bwofIssuedDate"].toString()) : undefined as any;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : undefined as any;
            this.whenUpdated = _data["whenUpdated"] ? new Date(_data["whenUpdated"].toString()) : undefined as any;
            this.ownerContact = _data["ownerContact"] ? ContactData.fromJS(_data["ownerContact"]) : undefined as any;
        }
    }

    static fromJS(data: any): PropertyBwofData {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyBwofData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["ownerContactId"] = this.ownerContactId;
        data["bwofIssuedBy"] = this.bwofIssuedBy;
        data["complianceScheduleMonths"] = this.complianceScheduleMonths;
        data["bwofLocated"] = this.bwofLocated;
        data["buildingSafetyManualLocated"] = this.buildingSafetyManualLocated;
        data["buildingSafetyManualIssuedOrUpdated"] = this.buildingSafetyManualIssuedOrUpdated ? this.buildingSafetyManualIssuedOrUpdated.toISOString() : undefined as any;
        data["complianceSchedule"] = this.complianceSchedule;
        data["complianceScheduleOnFile"] = this.complianceScheduleOnFile;
        data["buildingConsent"] = this.buildingConsent;
        data["codeComplianceCertificate"] = this.codeComplianceCertificate;
        data["fireReportOnFile"] = this.fireReportOnFile;
        data["ownerInspectionsCompletedBy"] = this.ownerInspectionsCompletedBy;
        data["compassDoTestingOrMaintenance"] = this.compassDoTestingOrMaintenance;
        data["legalDescription"] = this.legalDescription;
        data["locationOfBuildingWithinSite"] = this.locationOfBuildingWithinSite;
        data["buildingUse"] = this.buildingUse;
        data["purposeGroup"] = this.purposeGroup;
        data["highestFireHazardCategoryFhcNumber"] = this.highestFireHazardCategoryFhcNumber;
        data["maximumNumberOfOccupants"] = this.maximumNumberOfOccupants;
        data["levelUnitNo"] = this.levelUnitNo;
        data["firstConstructed"] = this.firstConstructed;
        data["intendedLifeOfTheBuilding"] = this.intendedLifeOfTheBuilding;
        data["issuedBy"] = this.issuedBy;
        data["bwofIssuedDate"] = this.bwofIssuedDate ? this.bwofIssuedDate.toISOString() : undefined as any;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : undefined as any;
        data["whenUpdated"] = this.whenUpdated ? this.whenUpdated.toISOString() : undefined as any;
        data["ownerContact"] = this.ownerContact ? this.ownerContact.toJSON() : undefined as any;
        return data;
    }
}

export interface IPropertyBwofData {
    propertyId?: number;
    ownerContactId?: number | undefined;
    bwofIssuedBy?: string | undefined;
    complianceScheduleMonths?: number | undefined;
    bwofLocated?: string | undefined;
    buildingSafetyManualLocated?: string | undefined;
    buildingSafetyManualIssuedOrUpdated?: Date | undefined;
    complianceSchedule?: string | undefined;
    complianceScheduleOnFile?: boolean;
    buildingConsent?: string | undefined;
    codeComplianceCertificate?: string | undefined;
    fireReportOnFile?: boolean;
    ownerInspectionsCompletedBy?: string | undefined;
    compassDoTestingOrMaintenance?: boolean;
    legalDescription?: string | undefined;
    locationOfBuildingWithinSite?: string | undefined;
    buildingUse?: string | undefined;
    purposeGroup?: string | undefined;
    highestFireHazardCategoryFhcNumber?: string | undefined;
    maximumNumberOfOccupants?: string | undefined;
    levelUnitNo?: string | undefined;
    firstConstructed?: string | undefined;
    intendedLifeOfTheBuilding?: string | undefined;
    issuedBy?: string | undefined;
    bwofIssuedDate?: Date | undefined;
    whenCreated?: Date | undefined;
    whenUpdated?: Date | undefined;
    ownerContact?: ContactData | undefined;
}

export class PropertyEvacuationData implements IPropertyEvacuationData {
    propertyId?: number;
    fireEvacuationServiceType?: string | undefined;
    fireEvacuationManualLastUpdated?: Date | undefined;
    wardenTraining?: string | undefined;
    fireAlarmType?: string | undefined;
    fireAlarmPanelLocated?: string | undefined;
    fireAlarmMonitoredBy?: string | undefined;
    securityAlarmType?: string | undefined;
    nzfsApprovalRequired?: boolean;
    nzfsApproval?: Date | undefined;
    nzfApplicationDate?: Date | undefined;
    schemeReference?: string | undefined;
    whenCreated?: Date | undefined;
    whenUpdated?: Date | undefined;

    constructor(data?: IPropertyEvacuationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.fireEvacuationServiceType = _data["fireEvacuationServiceType"];
            this.fireEvacuationManualLastUpdated = _data["fireEvacuationManualLastUpdated"] ? new Date(_data["fireEvacuationManualLastUpdated"].toString()) : undefined as any;
            this.wardenTraining = _data["wardenTraining"];
            this.fireAlarmType = _data["fireAlarmType"];
            this.fireAlarmPanelLocated = _data["fireAlarmPanelLocated"];
            this.fireAlarmMonitoredBy = _data["fireAlarmMonitoredBy"];
            this.securityAlarmType = _data["securityAlarmType"];
            this.nzfsApprovalRequired = _data["nzfsApprovalRequired"];
            this.nzfsApproval = _data["nzfsApproval"] ? new Date(_data["nzfsApproval"].toString()) : undefined as any;
            this.nzfApplicationDate = _data["nzfApplicationDate"] ? new Date(_data["nzfApplicationDate"].toString()) : undefined as any;
            this.schemeReference = _data["schemeReference"];
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : undefined as any;
            this.whenUpdated = _data["whenUpdated"] ? new Date(_data["whenUpdated"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PropertyEvacuationData {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyEvacuationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["fireEvacuationServiceType"] = this.fireEvacuationServiceType;
        data["fireEvacuationManualLastUpdated"] = this.fireEvacuationManualLastUpdated ? this.fireEvacuationManualLastUpdated.toISOString() : undefined as any;
        data["wardenTraining"] = this.wardenTraining;
        data["fireAlarmType"] = this.fireAlarmType;
        data["fireAlarmPanelLocated"] = this.fireAlarmPanelLocated;
        data["fireAlarmMonitoredBy"] = this.fireAlarmMonitoredBy;
        data["securityAlarmType"] = this.securityAlarmType;
        data["nzfsApprovalRequired"] = this.nzfsApprovalRequired;
        data["nzfsApproval"] = this.nzfsApproval ? this.nzfsApproval.toISOString() : undefined as any;
        data["nzfApplicationDate"] = this.nzfApplicationDate ? this.nzfApplicationDate.toISOString() : undefined as any;
        data["schemeReference"] = this.schemeReference;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : undefined as any;
        data["whenUpdated"] = this.whenUpdated ? this.whenUpdated.toISOString() : undefined as any;
        return data;
    }
}

export interface IPropertyEvacuationData {
    propertyId?: number;
    fireEvacuationServiceType?: string | undefined;
    fireEvacuationManualLastUpdated?: Date | undefined;
    wardenTraining?: string | undefined;
    fireAlarmType?: string | undefined;
    fireAlarmPanelLocated?: string | undefined;
    fireAlarmMonitoredBy?: string | undefined;
    securityAlarmType?: string | undefined;
    nzfsApprovalRequired?: boolean;
    nzfsApproval?: Date | undefined;
    nzfApplicationDate?: Date | undefined;
    schemeReference?: string | undefined;
    whenCreated?: Date | undefined;
    whenUpdated?: Date | undefined;
}

export abstract class BaseQueryOfListOfProperty implements IBaseQueryOfListOfProperty {

    constructor(data?: IBaseQueryOfListOfProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseQueryOfListOfProperty {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfListOfProperty' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseQueryOfListOfProperty {
}

export class GetPropertyListQuery extends BaseQueryOfListOfProperty implements IGetPropertyListQuery {
    queryString?: string | undefined;
    recordLimit?: number | undefined;
    onlyActive?: boolean;
    filterNorthIsland?: boolean;
    filterSouthIsland?: boolean;

    constructor(data?: IGetPropertyListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.queryString = _data["queryString"];
            this.recordLimit = _data["recordLimit"];
            this.onlyActive = _data["onlyActive"];
            this.filterNorthIsland = _data["filterNorthIsland"];
            this.filterSouthIsland = _data["filterSouthIsland"];
        }
    }

    static override fromJS(data: any): GetPropertyListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertyListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queryString"] = this.queryString;
        data["recordLimit"] = this.recordLimit;
        data["onlyActive"] = this.onlyActive;
        data["filterNorthIsland"] = this.filterNorthIsland;
        data["filterSouthIsland"] = this.filterSouthIsland;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPropertyListQuery extends IBaseQueryOfListOfProperty {
    queryString?: string | undefined;
    recordLimit?: number | undefined;
    onlyActive?: boolean;
    filterNorthIsland?: boolean;
    filterSouthIsland?: boolean;
}

export abstract class BaseQueryOfListOfPropertyServiceAuditDto implements IBaseQueryOfListOfPropertyServiceAuditDto {

    constructor(data?: IBaseQueryOfListOfPropertyServiceAuditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseQueryOfListOfPropertyServiceAuditDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfListOfPropertyServiceAuditDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseQueryOfListOfPropertyServiceAuditDto {
}

export class GetPropertyServiceAuditQuery extends BaseQueryOfListOfPropertyServiceAuditDto implements IGetPropertyServiceAuditQuery {
    queryString?: string | undefined;
    serviceId?: number | undefined;
    activeProperty?: boolean;
    activeService?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IGetPropertyServiceAuditQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.queryString = _data["queryString"];
            this.serviceId = _data["serviceId"];
            this.activeProperty = _data["activeProperty"];
            this.activeService = _data["activeService"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): GetPropertyServiceAuditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertyServiceAuditQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queryString"] = this.queryString;
        data["serviceId"] = this.serviceId;
        data["activeProperty"] = this.activeProperty;
        data["activeService"] = this.activeService;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPropertyServiceAuditQuery extends IBaseQueryOfListOfPropertyServiceAuditDto {
    queryString?: string | undefined;
    serviceId?: number | undefined;
    activeProperty?: boolean;
    activeService?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class ServiceData implements IServiceData {
    serviceId?: number;
    parentServiceId?: number | undefined;
    serviceName?: string | undefined;
    serviceShortName?: string | undefined;
    buildingAct?: string | undefined;
    isCategory?: boolean;
    sort1?: number | undefined;
    sort2?: number | undefined;
    intervalMonths?: number | undefined;
    description?: string | undefined;
    fullServicePrice?: number | undefined;
    auditPrice?: number | undefined;
    councilCodes?: string | undefined;
    active?: boolean;
    whenCreated?: Date | undefined;

    constructor(data?: IServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.parentServiceId = _data["parentServiceId"];
            this.serviceName = _data["serviceName"];
            this.serviceShortName = _data["serviceShortName"];
            this.buildingAct = _data["buildingAct"];
            this.isCategory = _data["isCategory"];
            this.sort1 = _data["sort1"];
            this.sort2 = _data["sort2"];
            this.intervalMonths = _data["intervalMonths"];
            this.description = _data["description"];
            this.fullServicePrice = _data["fullServicePrice"];
            this.auditPrice = _data["auditPrice"];
            this.councilCodes = _data["councilCodes"];
            this.active = _data["active"];
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["parentServiceId"] = this.parentServiceId;
        data["serviceName"] = this.serviceName;
        data["serviceShortName"] = this.serviceShortName;
        data["buildingAct"] = this.buildingAct;
        data["isCategory"] = this.isCategory;
        data["sort1"] = this.sort1;
        data["sort2"] = this.sort2;
        data["intervalMonths"] = this.intervalMonths;
        data["description"] = this.description;
        data["fullServicePrice"] = this.fullServicePrice;
        data["auditPrice"] = this.auditPrice;
        data["councilCodes"] = this.councilCodes;
        data["active"] = this.active;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : undefined as any;
        return data;
    }
}

export interface IServiceData {
    serviceId?: number;
    parentServiceId?: number | undefined;
    serviceName?: string | undefined;
    serviceShortName?: string | undefined;
    buildingAct?: string | undefined;
    isCategory?: boolean;
    sort1?: number | undefined;
    sort2?: number | undefined;
    intervalMonths?: number | undefined;
    description?: string | undefined;
    fullServicePrice?: number | undefined;
    auditPrice?: number | undefined;
    councilCodes?: string | undefined;
    active?: boolean;
    whenCreated?: Date | undefined;
}

export abstract class BaseQueryOfListOfServiceData implements IBaseQueryOfListOfServiceData {

    constructor(data?: IBaseQueryOfListOfServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseQueryOfListOfServiceData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfListOfServiceData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseQueryOfListOfServiceData {
}

export class GetAllAccessibleServicesQuery extends BaseQueryOfListOfServiceData implements IGetAllAccessibleServicesQuery {
    sortType?: string;
    onlyServicesInUse?: boolean | undefined;
    activeServicesOnly?: boolean;
    onlyParentServices?: boolean;

    constructor(data?: IGetAllAccessibleServicesQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sortType = _data["sortType"];
            this.onlyServicesInUse = _data["onlyServicesInUse"];
            this.activeServicesOnly = _data["activeServicesOnly"];
            this.onlyParentServices = _data["onlyParentServices"];
        }
    }

    static override fromJS(data: any): GetAllAccessibleServicesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAccessibleServicesQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortType"] = this.sortType;
        data["onlyServicesInUse"] = this.onlyServicesInUse;
        data["activeServicesOnly"] = this.activeServicesOnly;
        data["onlyParentServices"] = this.onlyParentServices;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAllAccessibleServicesQuery extends IBaseQueryOfListOfServiceData {
    sortType?: string;
    onlyServicesInUse?: boolean | undefined;
    activeServicesOnly?: boolean;
    onlyParentServices?: boolean;
}

export class UserData implements IUserData {
    loginId?: number;
    loginEmail?: string;
    accessRoles?: string;
    whenLastLogin?: Date | undefined;
    loginCount?: number;
    isCompassStaff?: boolean;
    isExternalCustomer?: boolean;
    isExternalSupplier?: boolean;
    whenCreated?: Date | undefined;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;

    constructor(data?: IUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginId = _data["loginId"];
            this.loginEmail = _data["loginEmail"];
            this.accessRoles = _data["accessRoles"];
            this.whenLastLogin = _data["whenLastLogin"] ? new Date(_data["whenLastLogin"].toString()) : undefined as any;
            this.loginCount = _data["loginCount"];
            this.isCompassStaff = _data["isCompassStaff"];
            this.isExternalCustomer = _data["isExternalCustomer"];
            this.isExternalSupplier = _data["isExternalSupplier"];
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : undefined as any;
            this.whenUpdated = _data["whenUpdated"] ? new Date(_data["whenUpdated"].toString()) : undefined as any;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserData {
        data = typeof data === 'object' ? data : {};
        let result = new UserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginId"] = this.loginId;
        data["loginEmail"] = this.loginEmail;
        data["accessRoles"] = this.accessRoles;
        data["whenLastLogin"] = this.whenLastLogin ? this.whenLastLogin.toISOString() : undefined as any;
        data["loginCount"] = this.loginCount;
        data["isCompassStaff"] = this.isCompassStaff;
        data["isExternalCustomer"] = this.isExternalCustomer;
        data["isExternalSupplier"] = this.isExternalSupplier;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : undefined as any;
        data["whenUpdated"] = this.whenUpdated ? this.whenUpdated.toISOString() : undefined as any;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserData {
    loginId?: number;
    loginEmail?: string;
    accessRoles?: string;
    whenLastLogin?: Date | undefined;
    loginCount?: number;
    isCompassStaff?: boolean;
    isExternalCustomer?: boolean;
    isExternalSupplier?: boolean;
    whenCreated?: Date | undefined;
    whenUpdated?: Date | undefined;
    whenDeleted?: Date | undefined;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    loginId!: number;
    password!: string;
    passwordReEntered!: string;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginId = _data["loginId"];
            this.password = _data["password"];
            this.passwordReEntered = _data["passwordReEntered"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginId"] = this.loginId;
        data["password"] = this.password;
        data["passwordReEntered"] = this.passwordReEntered;
        return data;
    }
}

export interface IChangePasswordRequest {
    loginId: number;
    password: string;
    passwordReEntered: string;
}

export class UpdateUserDetailsCommand extends BaseCommandOfBoolean implements IUpdateUserDetailsCommand {
    userDetails?: UserData;

    constructor(data?: IUpdateUserDetailsCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetails = _data["userDetails"] ? UserData.fromJS(_data["userDetails"]) : undefined as any;
        }
    }

    static override fromJS(data: any): UpdateUserDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDetailsCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetails"] = this.userDetails ? this.userDetails.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateUserDetailsCommand extends IBaseCommandOfBoolean {
    userDetails?: UserData;
}

export class AddUserCommand extends BaseCommandOfInteger implements IAddUserCommand {
    userDetails?: NewUserData;

    constructor(data?: IAddUserCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetails = _data["userDetails"] ? NewUserData.fromJS(_data["userDetails"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AddUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetails"] = this.userDetails ? this.userDetails.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAddUserCommand extends IBaseCommandOfInteger {
    userDetails?: NewUserData;
}

export class NewUserData implements INewUserData {
    loginId?: number;
    loginEmail?: string;
    password?: string;
    accessRoles?: string;

    constructor(data?: INewUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginId = _data["loginId"];
            this.loginEmail = _data["loginEmail"];
            this.password = _data["password"];
            this.accessRoles = _data["accessRoles"];
        }
    }

    static fromJS(data: any): NewUserData {
        data = typeof data === 'object' ? data : {};
        let result = new NewUserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginId"] = this.loginId;
        data["loginEmail"] = this.loginEmail;
        data["password"] = this.password;
        data["accessRoles"] = this.accessRoles;
        return data;
    }
}

export interface INewUserData {
    loginId?: number;
    loginEmail?: string;
    password?: string;
    accessRoles?: string;
}

export class UpdateSignatureCommand extends BaseCommandOfBoolean implements IUpdateSignatureCommand {
    signatureBase64?: string | undefined;

    constructor(data?: IUpdateSignatureCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.signatureBase64 = _data["signatureBase64"];
        }
    }

    static override fromJS(data: any): UpdateSignatureCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSignatureCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signatureBase64"] = this.signatureBase64;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateSignatureCommand extends IBaseCommandOfBoolean {
    signatureBase64?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

// The lines from api-header.ts are included as the first lines of api-client.ts when NSwag generates api-client.ts
// Hence api-header.ts is not accessed directly, but is used to add references within api-client.